import { ru } from './ru.js';

export const zhHans = {
  phoneInput: {
    label: '电话',
    favorites: '收藏',
    changeCountry: '更改国家',
    search: {
      placeholder: '搜索国家（名称、代码）',
      noResults: '无匹配项',
    },
  },
  auth: {
    login: {
      footer: '没有访问权限？请联系管理员。',
      password: '密码',
      pending: '正在登录…',
      submit: '登录',
      subtitle: '请输入你的凭据',
      title: '登录',
    },
    password: {
      copied: '已复制',
      copy: '复制',
      copyFailed: '复制失败',
      generate: '生成密码',
      revealToggle: '显示/隐藏',
    },
  },
  common: {
    a11y: {
      skipToContent: '跳到主要内容',
    },
    actions: {
      activeOnly: '仅显示启用',
      archive: '归档',
      back: '返回',
      cancel: '取消',
      close: '关闭',
      contact: '联系',
      confirm: '确认',
      create: '创建',
      delete: '删除',
      deactivate: '停用',
      edit: '编辑',
      goHome: '返回首页',
      more: '更多',
      next: '下一页',
      reactivate: '重新启用',
      reload: '重新加载',
      rename: '重命名',
      resetPassword: '重置密码',
      restore: '恢复',
      retry: '重试',
      save: '保存',
      select: '选择',
      showArchive: '显示归档',
      uploadFile: '上传文件',
    },
    confirm: {
      title: '请确认',
    },
    filters: {
      allPrefix: '全部：{{label}}',
      rangeMax: '至',
      rangeMin: '从',
    },
    fields: {
      optional: '可选',
      reasonPlaceholder: '原因…',
    },
    locales: {
      en: 'English',
      ru: 'Русский',
      zhHans: '简体中文',
    },
    pagination: {
      pageOfTotal: '第 {{page}} 页，共 {{pages}} 页 · 总计 {{total}}',
    },
    dataTable: {
      sortBy: '排序',
      sortDirection: {
        asc: '升序',
        desc: '降序',
      },
    },
    combobox: {
      noResults: '无结果',
    },
    states: {
      emptyTitle: '暂无数据',
      errorText: '无法加载数据。',
      errorTitle: '错误',
      forbiddenText: '你没有权限查看此页面。',
      forbiddenTitle: '无访问权限',
      loadError: '无法加载',
      loading: '加载中…',
      minimumReason: '至少 3 个字符',
      restoringSession: '正在恢复会话…',
    },
    status: {
      active: '启用',
      activeFeminine: '启用',
      archive: '归档',
      archived: '已归档',
      closed: '已关闭',
      draft: '草稿',
      inWork: '处理中',
      inactive: '停用',
      passwordResetRequired: '需要修改密码',
      processed: '已处理',
      return: '退回',
      system: '系统',
    },
    units: {
      byte: 'B',
      cubicMeterShort: 'm³',
      dayShort: '天',
      hourShort: '小时',
      kilogramShort: 'kg',
      kilobyte: 'KB',
      megabyte: 'MB',
      minuteShort: '分钟',
    },
    unsavedChanges: {
      title: '存在未保存的更改',
      body: '有未保存的更改。继续编辑还是不保存就关闭？',
      continueEditing: '继续编辑',
      closeWithoutSaving: '不保存就关闭',
    },
  },
  shell: {
    appError: {
      text: '发生意外错误。请尝试重新加载页面。',
      title: '出现问题',
    },
    language: {
      label: '语言',
    },
    moduleError: {
      text: '无法显示此页面。',
      title: '模块错误',
    },
    nav: {
      groups: {
        admin: '管理',
        crm: 'CRM',
        dashboards: '仪表板',
        finance: '财务',
        logistics: '物流',
        refs: '基础资料',
        work: '工作',
      },
      items: {
        agent: '智能体',
        myDashboards: '我的仪表板',
        arrivalCities: '到达城市',
        audit: '审计日志',
        calls: '呼叫中心',
        cargo: '货物',
        cargoProblems: '货物：问题',
        carriers: '承运商',
        chinaRates: '中国报价',
        chinaRequestsDashboard: '中国需求',
        clients: '客户',
        commercialProposals: '商业报价',
        logisticsCalculations: '运单',
        crmIntakeAdmin: '呼叫中心与值班',
        deals: '交易',
        depts: '部门',
        leads: '线索',
        payments: '付款申请',
        prices: '价格表',
        queues: '队列',
        revenue: '营收',
        roles: '角色',
        russiaCarriers: '俄方承运商',
        russiaRates: '俄罗斯报价',
        sla: 'SLA 控制',
        sources: '来源',
        stages: '阶段',
        tasks: '任务',
        transportTypes: '运输类型',
        roadOptions: '路线',
        packagingOptions: '包装',
        users: '用户',
        warehouses: '仓库',
        warehousesChina: '中国仓库',
      },
    },
    notFound: {
      text: '页面不存在。',
      title: '未找到',
    },
    placeholder: {
      text: '此页面将在下一阶段迁移中提供。',
      title: '即将推出',
    },
    profile: {
      changePassword: '修改密码…',
      logout: '退出登录',
      menu: '个人资料菜单',
      profile: '个人资料',
      settings: '设置',
    },
    sidebar: {
      collapse: '收起',
      collapseMenu: '收起菜单',
      expand: '展开',
      expandMenu: '展开菜单',
    },
    topbar: {
      menu: '菜单',
      onShift: {
        label: '值班中',
        ariaOn: '正在值班 — 点击下班',
        ariaOff: '未值班 — 点击上班',
      },
    },
    bell: {
      button: '通知',
      loading: '加载中…',
      loadError: '无法加载通知',
      empty: '暂无通知',
      unreadHeader: '未读',
      recentHeader: '最近',
      unreadDescription: {
        chat: '{{count}} 条新聊天消息',
        rate: '{{count}} 条新承运人报价',
        rejection: '{{count}} 次承运人拒绝',
        insurance: '{{count}} 条保险事件',
        responsibleStatus: '负责人变更',
        leadCallback: '客户请求回电：{{count}} 次',
        cargoProblem: '货物问题事件：{{count}}',
      },
      recentDescription: {
        chat: '聊天',
        rate: '承运人报价',
        rejection: '承运人拒绝',
        insurance: '保险',
        responsibleStatus: '负责人',
        leadCallback: '客户请求回电',
        cargoProblem: '货物问题',
      },
    },
    messages: { button: '消息' },
    notificationsRow: {
      aria: {
        dot: '有未读通知',
        count_one: '{{count}} 条未读通知',
        count_few: '{{count}} 条未读通知',
        count_many: '{{count}} 条未读通知',
        count_other: '{{count}} 条未读通知',
        countCapped: '{{count}}+ 条未读通知',
      },
    },
    workspaceTab: {
      aria: {
        notifications: {
          count_one: '{{count}} 条未读通知',
          count_few: '{{count}} 条未读通知',
          count_many: '{{count}} 条未读通知',
          count_other: '{{count}} 条未读通知',
          countCapped: '{{count}}+ 条未读通知',
        },
      },
    },
  },
  settings: {
    title: '设置',
    theme: {
      heading: '主题',
      light: '浅色',
      dark: '深色',
    },
    language: {
      heading: '语言',
    },
    notifications: {
      heading: '通知',
      loading: '加载中…',
      loadError: '无法加载通知设置',
      previewButton: '试听',
      previewAriaLabel: '播放声音预览',
      previewFailed: '无法播放声音',
      soundOption: '声音 {{index}}',
      soundSelectLabel: '通知声音',
      groups: {
        chat: '聊天消息',
        rates: '报价、拒绝、保险',
        responsibleStatus: '责任人变更',
      },
    },
  },
  profile: {
    title: '个人资料',
    sections: {
      view: '个人信息',
      edit: '编辑',
    },
    fields: {
      name: '姓名',
      email: '邮箱',
      phone: '电话',
      role: '角色',
      department: '部门',
      createdAt: '注册时间',
    },
    actions: {
      save: '保存',
      changePassword: '修改密码',
    },
    toasts: {
      saved: '个人资料已更新',
    },
    errors: {
      nameRequired: '请输入姓名',
      nameTooLong: '姓名过长（最多 200 个字符）',
      invalidPhone: '请按国际格式输入号码，例如 +79991234567',
    },
    placeholders: {
      missing: '—',
    },
  },
  errors: {
    auth: {
      invalidCredentials: '邮箱或密码无效',
      refreshInvalid: '会话已过期。请重新登录',
      refreshReused: '检测到可疑活动。请重新登录',
      tokenInvalid: '会话已过期。请重新登录',
      unauthorized: '会话已过期。请重新登录',
      wrongCurrentPassword: '当前密码不正确',
    },
    domain: {
      actorHasOpenAssignment: '用户尚有未完成的请求。请先将其改派给其他物流员',
      cannotModifySelf: '不能编辑自己或重置自己的密码',
      conflict: '数据冲突。请刷新页面',
      forbidden: '权限不足',
      gateFailed: '不满足执行条件',
      invalidTransition: '当前状态不允许执行此操作',
      noLogistAvailable: '当前没有物流员在班。请等待物流员上班',
      notFound: '对象未找到',
      permissionsStale: '权限已在其他会话中变更。请刷新该角色后重试',
      phoneAlreadyExists: '该电话号码已被其他记录使用',
      callCenterOwnDuplicate: '您已提交过使用此电话号码的线索',
      processNoAnsweredCarrier: '无法标记为已处理：暂无承运商应答',
      reasonRequired: '请填写原因',
      requestItemMissingPhoto: '每个货物项必须有 1 张照片',
      returnBlockedByAnsweredCarrier: '无法退回：承运商已有报价。请先重置、拒绝或删除这些报价',
      winnerRequired: '请选择获胜报价',
      shiftCannotLeaveLast: '无法下班：您是最后一名在班物流员',
      storageForbidden: '无权访问该文件',
      userEmailTaken: '该邮箱的用户已存在',
      userNotFound: '用户未找到',
      validation: '请检查输入的数据',
    },
    generic: {
      unavailable: '服务不可用。请重试',
    },
    rateLimit: {
      exceeded: '尝试次数过多。请等待一分钟',
    },
  },
  rbac: {
    actions: {
      savePermissions: '保存权限',
    },
    groups: {
      accounts: '账户',
      agent: 'AI 智能体',
      arrivalCities: '到达城市',
      audit: '审计日志',
      callCenterLeads: '呼叫中心线索',
      calls: '通话',
      cargo: '货物',
      cargoProblems: '货物问题',
      carriers: '承运商',
      chat: '聊天',
      clients: '客户',
      commercialProposals: '商业报价',
      logisticsCalculations: '物流计算',
      companies: '公司',
      dashboard: '仪表板',
      deals: '交易',
      departments: '部门',
      leads: '线索',
      packaging: '包装',
      paymentClaims: '付款申请',
      payments: '付款',
      priceLists: '价格表',
      requests: '请求',
      roads: '路线',
      roles: '角色',
      russiaCarriers: '俄方承运商',
      russiaRequests: '俄罗斯请求',
      sources: '来源',
      stages: '阶段',
      tasks: '任务',
      transitions: '请求状态流转',
      transportTypes: '运输类型',
      users: '用户',
      warehouses: '仓库',
      warehousesChina: '中国仓库',
    },
    permissions: {
      accounts: {
        manage: '管理账户',
        read: '查看账户',
      },
      agent: {
        admin: 'AI 智能体管理（提示词、调试、SQL）',
      },
      arrivalCities: {
        manage: '管理到达城市',
        read: '查看到达城市',
      },
      audit: {
        read: '查看审计日志',
      },
      callCenterLeads: {
        readOwn: '查看本人呼叫中心线索',
        submit: '提交呼叫中心线索',
      },
      calls: {
        manage: '管理通话',
        read: '查看通话',
      },
      cargo: {
        carrierPayment: {
          manage: '设置货物承运商付款状态',
        },
        chinaPayment: {
          manage: '设置货物中国付款金额',
        },
        clientPayment: {
          manage: '设置货物客户付款状态',
          quickManage: '快速标记货物客户已全额付款',
          review: '审核客户付款（俄罗斯财务）',
        },
        clientPaymentDocs: {
          manage: '管理货物客户付款单据',
        },
        clientTariff: {
          manage: '设置货物客户运输费率',
        },
        create: '创建货物',
        delete: '删除货物',
        dictionaries: {
          manage: '管理货物字典',
          read: '查看货物字典',
        },
        import: '导入货物文件',
        manage: '管理货物',
        read: '查看货物',
        scope: {
          all: '查看所有货物（解除仅限所有者的范围）',
        },
        update: '更新货物',
      },
      cargoProblems: {
        assignee: { manage: '重新分配货物问题负责人' },
        attachments: { delete: '删除已发布的货物问题附件' },
        create: '创建货物问题',
        read: '查看货物问题',
        scope: { all: '查看所有已提交的货物问题' },
        work: { china: '处理中国队列', russia: '处理俄罗斯队列' },
      },
      carriers: {
        manage: '管理承运商',
        read: '查看承运商',
      },
      chat: {
        manage: '管理聊天',
        read: '查看聊天',
      },
      clients: {
        manage: '管理客户',
        read: '查看客户',
      },
      commercialProposals: {
        manage: '管理商业报价',
        read: '查看商业报价',
      },
      logisticsCalculations: {
        manage: '管理物流计算',
        read: '查看物流计算',
      },
      companies: {
        manage: '管理公司',
        read: '查看公司',
      },
      dashboard: {
        read: '查看仪表板',
      },
      deals: {
        manage: '管理交易',
        read: '查看交易',
      },
      departments: {
        manage: '管理部门',
        read: '查看部门',
      },
      leads: {
        assign: '分配线索',
        manage: '管理线索',
        read: '查看线索',
        scope: {
          all: '查看所有线索（解除「仅自己」限制）',
        },
      },
      packaging: {
        manage: '管理包装',
        read: '查看包装',
      },
      paymentClaims: {
        manage: '管理付款申请',
        read: '查看付款申请',
      },
      payments: {
        manage: '管理付款',
        read: '查看付款',
      },
      priceLists: {
        manage: '管理价格表',
        read: '查看价格表',
      },
      requests: {
        export: { bulk: '批量导出请求' },
        manage: '管理请求',
        read: '查看请求',
        scope: {
          all: '查看所有请求（解除「仅自己」限制）',
        },
        transition: {
          archive: '请求流转：归档',
          close: '请求流转：关闭',
          process: '请求流转：处理',
          reopen: '请求流转：重新打开',
          return: '请求流转：退回',
          send: '请求流转：发送',
          unarchive: '请求流转：从归档恢复',
          success: '请求流转：确认成功',
          refuse: '请求流转：确认拒单',
          postpone: '请求流转：搁置',
          cannotTransport: '请求流转：无法承运',
        },
      },
      roads: {
        manage: '管理路线',
        read: '查看路线',
      },
      roles: {
        manage: '管理角色',
        read: '查看角色',
      },
      russiaCarriers: {
        manage: '俄方承运商：管理',
        read: '俄方承运商：读取',
      },
      russiaRequests: {
        manage: '管理俄罗斯请求',
        read: '查看俄罗斯请求',
        scope: {
          all: '查看所有俄罗斯请求（解除「仅自己」限制）',
        },
        transition: {
          archive: '俄罗斯请求流转：归档',
          close: '俄罗斯请求流转：关闭',
          process: '俄罗斯请求流转：处理',
          reopen: '俄罗斯请求流转：重新打开',
          return: '俄罗斯请求流转：退回',
          send: '俄罗斯请求流转：发送',
          unarchive: '俄罗斯请求流转：从归档恢复',
          success: '俄罗斯请求流转：标记成功',
          refuse: '俄罗斯请求流转：标记拒绝',
          postpone: '俄罗斯请求流转：搁置',
        },
      },
      sources: {
        manage: '管理来源',
        read: '查看来源',
      },
      stages: {
        manage: '管理阶段',
        read: '查看阶段',
      },
      tasks: {
        manage: '管理任务',
        read: '查看任务',
      },
      transportTypes: {
        manage: '管理运输类型',
        read: '查看运输类型',
      },
      users: {
        manage: '管理用户',
        read: '查看用户',
      },
      warehouses: {
        manage: '管理仓库',
        read: '查看仓库',
      },
      warehousesChina: {
        manage: '管理中国仓库',
        read: '查看中国仓库',
      },
    },
  },
  unreadBadge: {
    markedUnread: '标记为未读',
    count_one: '{{count}} 条未读消息',
    count_few: '{{count}} 条未读消息',
    count_many: '{{count}} 条未读消息',
    count_other: '{{count}} 条未读消息',
    capped: '超过 {{count}} 条未读消息',
    attentionCount_one: '{{count}} 个问题需要关注',
    attentionCount_few: '{{count}} 个问题需要关注',
    attentionCount_many: '{{count}} 个问题需要关注',
    attentionCount_other: '{{count}} 个问题需要关注',
    attentionCapped: '超过 {{count}} 个问题需要关注',
  },
  requests: {
    actions: {
      archive: '归档',
      close: '关闭请求',
      process: '标记为已处理',
      processDisabledNoAnswered: '等待至少一家承运商应答',
      reopen: '重新打开',
      return: '退回修改',
      send: '发送处理',
      unarchive: '恢复',
      success: '确认成功',
      refuse: '确认拒单',
      cannotTransport: '无法承运',
      postpone: '搁置',
      duplicate: '复制',
      russiaRate: {
        button: '俄罗斯运价',
        tooltip: {
          disabledEmptyCargo: '请先添加货品或箱子，才能创建俄罗斯运价请求。',
          openExisting: '打开已有的俄罗斯运价请求。',
          create: '基于此请求创建俄罗斯运价请求。',
          creating: '正在创建俄罗斯运价请求…',
          error: '创建俄罗斯运价请求失败，请重试。',
        },
        create: {
          title: '创建俄罗斯运价请求',
          addressLabel: '送货地址',
          addressRequired: '请填写送货地址。',
          confirm: '创建请求',
          cancel: '取消',
        },
      },
    },
    audit: {
      empty: '暂无日志事件',
    },
    boxRegroup: {
      action: {
        edit: '编辑分组',
      },
      editor: {
        title: '将物品重新分配到分组',
      },
      toast: {
        saved: '物品分组已更新',
        stale: '该箱已被他人更新，请刷新后重试。',
        overrideConflict: '无法保存：承运商在即将清空的分组上设置了费率或保险。',
        failed: '保存分组失败，请重试。',
      },
      conflicts: {
        title: '关联冲突',
        line: '分组 {{ordinal}}（{{domain}}）：{{carriers}}',
        domain: {
          bid: '费率',
          insurance: '保险',
        },
      },
    },
    export: {
      action: '下载 Excel',
      downloading: '正在准备文件…',
      error: '下载文件失败',
      bulk: {
        enterSelection: '选择',
        selectAll: '选择全部结果',
        selectingAll: '正在选择…',
        clear: '清除',
        exitSelection: '退出',
        open: '生成文件',
        title: '批量导出',
        confirm: '生成文件',
        includeRateColumns: '添加费率字段',
        selectedCount_one: '已选择 {{count}} 个请求',
        selectedCount_few: '已选择 {{count}} 个请求',
        selectedCount_many: '已选择 {{count}} 个请求',
        selectedCount_other: '已选择 {{count}} 个请求',
        selectColumn: '请求选择',
        selectRequest: '选择请求 {{id}}',
        capReached: '最多只能选择 20 个请求。',
        tooMany: '匹配结果超过 20 个。请缩小筛选范围后重试。',
        selectAllError: '无法选择全部结果，请重试。',
        missing: '未找到或无权访问以下请求：{{ids}}。',
        oversized: '请求 {{id}} 过大，无法导出。',
      },
    },
    funnel: {
      openLead: '打开关联线索 {{code}}',
      openDeal: '打开关联交易 {{code}}',
    },
    errors: {
      detailFetchFailed: '无法加载请求详情，请重试。',
    },
    rowGone: '该请求已不可用。',
    nextStep: {
      draft: {
        incomplete: '请填写缺失的字段并提交处理。还剩 {{count}} 个字段。',
        ready: '请求已就绪——提交处理。',
      },
      return: {
        incomplete: '请修正缺失的字段并重新提交。还剩 {{count}} 个字段。',
        ready: '已完成修改——重新提交请求。',
      },
      draftReadyPending: '请求已填写完毕。',
      returnReadyPending: '退货已填写完毕。',
      readyForWork: '等待物流专员接手该请求。',
      waitingAnswers: '等待承运商回复。',
      pickWinner: '承运商已回复——请选择中标方。',
      pickWinnerPending: '承运商回复已收到——等待选定中标方。',
      winnerSelected: '中标方已选定。',
      postponed: '请求已搁置',
      success: '请求已成功完成。',
      terminal: '请求已完成，无需操作。',
      action: {
        send: '立即提交',
        pickWinner: '前往选择',
      },
    },
    carriers: {
      add: '添加',
      addBid: '添加报价',
      addBidTitle: '新报价 — {{name}}',
      bid: {
        validUntil: '有效期至 {{date}}',
        notActualSince: '自 {{date}} 起失效',
        validityDaysPlaceholder: '报价有效期(天)',
        validityHint: '有效期为 {{min}} 到 {{max}} 之间的整数天，默认 {{defaultDays}} 天。',
        validityPreset: {
          thisWeek: '本周末之前',
          nextWeek: '下周末之前',
          days7: '7 天',
          days10: '10 天',
          days14: '14 天',
          manual: '手动输入',
        },
      },
      addPlaceholder: '选择承运商',
      answer: '回复',
      completedCount: '已响应 {{completed}} / {{total}}',
      answerTitle: '承运商回复 — {{name}}',
      bestOffers: '最佳报价',
      bids: '报价',
      cheapest: '最低价',
      columns: {
        carrier: '承运商',
        comment: '备注',
        conditions: '条件',
        days: '时效',
        price: '报价',
        sentAt: '已发送',
        status: '状态',
      },
      commentPlaceholder: '承运商备注',
      contact: '联系',
      daysMaxPlaceholder: '运输时间(天,最长)',
      daysMinPlaceholder: '运输时间(天,最短)',
      daysPlaceholder: '运输时间(天,可选)',
      daysShort: '{{days}} 天',
      daysShortRange: '{{min}}–{{max}} 天',
      destinationSection: {
        titleFull: '承运商 — {{name}}',
        titleShort: '承运商 — {{short}}',
      },
      generalSection: {
        title: '通用报价',
      },
      errors: {
        carrierCityNotInRequest: '目的城市不在请求的目的地中。',
        carrierAlreadyInCity: '此承运商已添加到该城市。',
        carrierAlreadyInRequest: '此承运商已添加到该请求。',
      },
      insurance: {
        section: '保险',
        noQuote: '尚无保险报价',
        addQuote: '添加保险百分比',
        addOverride: '添加细分',
        reconfirm: '重新确认',
        needsReconfirm: '货物价值已变更 — 请重新确认',
        percentLabel: '%',
        percentValue: '{{percent}}%',
        amountLabel: '金额',
        cargoValueLabel: '货物价值',
        commentLabel: '备注',
        commentPlaceholder: '可选备注',
        primary: {
          cannotDeleteWithOverrides: '存在细分时无法删除主报价。请先删除细分。',
        },
        scope: {
          request: { label: '整单' },
          item: { label: '物品：{{name}}' },
          box: { label: '箱 #{{n}}' },
          boxItem: { label: '箱 #{{n}} 中的物品：{{name}}' },
          boxGroup: { label: '箱 #{{n}} 中的分组 {{k}}' },
        },
        scopePicker: {
          placeholder: '选择目标',
          required: '请选择目标',
          noOptions: '没有剩余可细分的范围',
        },
        errors: {
          percentBounds: '百分比必须在 0 至 100 之间',
        },
      },
      editBidTitle: '编辑报价 — {{name}}',
      empty: '尚未邀请承运商',
      noBids: '暂无报价',
      pickWinner: '选择获胜方',
      pricePerUnitPlaceholder: '单价',
      pricePlaceholder: '配送价格',
      reject: '拒绝',
      rejectPlaceholder: '拒绝原因',
      rejectTitle: '承运商拒绝 — {{name}}',
      reset: '回到等待',
      state: {
        answered: '已回复',
        pending: '等待中',
        rejected: '拒绝',
      },
      total: '合计',
      unitKg: '每千克',
      unitM3: '每立方米',
      unitPiece: '每件',
      unitSuffix: {
        kg: '/千克',
        m3: '/立方米',
        piece: '/件',
      },
      winner: '获胜',
    },
    chat: {
      aria: {
        read: '对方已读',
        sent: '已发送',
      },
      empty: '暂无消息',
      markUnread: '标记为未读',
      newDivider: '新消息',
      placeholder: '以 {{name}} 身份发送消息…',
      roles: {
        admin: '管理员',
        logist_cn: '中国物流员',
        logist_ru: '俄罗斯物流员',
        manager: '经理',
      },
      send: '发送',
      unmarkUnread: '取消未读标记',
    },
    closeModal: {
      confirm: '确认关闭',
      noWinner: '关闭前必须选择获胜方 — 服务器要求。',
      pickWinner: '请从已回复承运商中选择获胜方。',
      title: '关闭请求 — {{id}}',
      winnerText: '请求将进入“已关闭”状态。获胜方：{{name}}。',
    },
    common: {
      attachments: '附件',
      autoSave: '自动保存',
      createdAt: '创建于 {{date}}',
      days: '{{count}} 天',
      density: '密度，千克/立方米',
      from: '起点',
      guest: '访客',
      items: '货物项',
      logist_cn: '中国物流员',
      manager: '经理',
      noName: '（未命名）',
      notAssigned: '未分配',
      route: '路线',
      to: '终点',
      updatedAt: '已更新',
      volume: '体积',
      weight: '重量',
    },
    draftDefaults: {
      from: '中国',
      to: '俄罗斯',
    },
    returnTemplates: {
      cancel: '我想取消该申请',
      addItems: '需要添加货物项',
      removeItems: '需要移除货物项',
      adjustWeightVolume: '需要调整重量 / 体积',
      attachPacking: '需要附上装箱单',
    },
    draft: {
      addItem: '添加货物项',
      deleteDraft: '删除草稿',
      deleteReturn: '删除退回',
      duplicateItem: '复制',
      emptyItems: '请至少添加一个货物项',
      frozen: {
        banner: '草稿已保存到服务器。如需修改，请重新开始——或再次尝试发送。',
      },
      fromPlaceholder: '中国发货城市',
      itemDescriptionPlaceholder: '简要说明货物项、内容或包装细节',
      itemNamePlaceholder: '货物项名称',
      newItemName: '新货物项',
      photoAttached: '已上传照片',
      photoAddMore: '添加更多照片',
      photoRemove: '删除照片',
      photoReplace: '更换照片',
      photoRetry: '重试',
      photoUpload: '上传照片',
      photoUploading: '上传中…',
      photoFromClipboard: '从剪贴板添加照片',
      ready: '可以发送给物流',
      photoDecodeFailed: '浏览器无法解码此图像格式：{{format}}。',
      photoEncodeFailed: '浏览器无法准备此图像以上传。',
      photoUploadFailed: '上传失败 — 请重试',
      startOver: '重新开始',
      save: '保存草稿',
      saveReturn: '保存退回',
      saving: '保存中…',
      savedReady: '已保存',
      unsavedDraft: '草稿尚未保存',
      unsavedChanges: '存在未保存的更改',
      confirmDiscard: '草稿有未保存的更改。关闭并丢弃这些更改吗?',
      closeConfirm: {
        titleUnsaved: '保存草稿?',
        titlePersisted: '保存草稿的更改?',
        bodyUnsaved: '草稿有未保存的更改。保存并关闭,还是关闭但不保存?',
        bodyPersisted: '草稿有未保存的更改。保存并关闭,还是关闭但不保存?',
        saveAndClose: '保存并关闭',
        continueEditing: '继续编辑',
        closeWithoutSaving: '不保存并关闭',
        confirmCloseWithoutSaving: '确认不保存并关闭?',
        discardArmedHint: '此操作无法撤销。',
        uploadingHint: '请等待照片上传完成 — 在此之前无法保存或关闭。',
      },
      deleteConfirm: {
        confirm: '确认删除草稿?',
        hint: '此操作无法撤销。',
        uploadingHint: '请等待照片上传完成。',
      },
      photoClipboard: {
        unsupported: '浏览器不支持读取剪贴板。',
        denied: '剪贴板访问被拒绝。',
        empty: '剪贴板中未找到受支持的图像。',
        failed: '无法从剪贴板读取图像。',
        unsupportedType: '不支持的图像类型。',
      },
      photoReplaceConfirm: {
        title: '更换照片?',
        body: '该货物项已有照片。是否用剪贴板中的图像替换?',
        confirm: '更换',
        cancel: '取消',
      },
      destinations: {
        label: '到货城市',
        empty: '尚未选择城市',
        add: '添加',
        pickerPlaceholder: '选择城市',
        remove: '移除 {{name}}',
      },
      deliveryAddress: {
        label: '交货地址',
        placeholder: '城市、街道、楼号、仓库或收件人联系方式',
      },
      pickupAddress: {
        label: '提货地址',
        placeholder: '城市、街道、楼号、仓库或发件人联系方式',
      },
      roads: {
        label: '路线',
        empty: '尚未选择路线',
        add: '添加',
        pickerPlaceholder: '选择路线',
        remove: '移除 {{name}}',
        catalogEmptyHint: '字典中没有可用项，请联系中国物流负责人。',
        catalogEmptyLink: '前往字典 →',
      },
      packaging: {
        label: '包装',
        empty: '尚未选择包装',
        add: '添加',
        pickerPlaceholder: '选择包装',
        remove: '移除 {{name}}',
        catalogEmptyHint: '字典中没有可用项，请联系中国物流负责人。',
        catalogEmptyLink: '前往字典 →',
      },
      dictionarySelections: {
        inactiveSuffix: '(已停用)',
      },
      container: {
        transportTypeLabel: '运输类型',
        pickerPlaceholder: '选择运输类型',
        capacityHint: '{{volumeMin}}–{{volumeMax}} m³ · {{payloadMin}}–{{payloadMax}} t',
      },
      insurance: {
        section: '保险',
        toggleLabel: '需要保险信息',
        cargoValueLabel: '货物价值',
        cargoValuePlaceholder: '例如 12000',
        cargoCurrencyLabel: '币种',
        cargoCurrencyPlaceholder: '选择币种',
      },
      required: {
        deliveryAddress: '容器交货地址',
        pickupAddress: '容器提货地址',
        destinations: '至少 1 个到货城市',
        from: '起点',
        insuranceTriplet: '保险所需的货物价值和币种',
        item: '至少 1 个货物项',
        itemOrBox: '至少添加 1 个货物项或 1 个箱子',
        itemDescription: '每个货物项都需要说明',
        itemName: '每个货物项需要名称',
        itemPhoto: '每个货物项需要照片',
        itemQuantity: '每个货物项都需要数量',
        itemVolume: '每个货物项体积必须大于 0',
        itemWeight: '每个货物项重量必须大于 0',
        boxItem: '每个箱子至少 1 个货物项',
        boxItemName: '每个箱内货物项需要名称',
        boxItemDescription: '每个箱内货物项需要说明',
        boxItemPhoto: '每个箱内货物项需要照片',
        boxItemQuantity: '每个箱内货物项数量必须大于 0',
        name: '名称',
        prefix: '请填写：',
        to: '终点',
        transportType: '运输类型',
        weight: '重量必须大于 0',
        volume: '体积必须大于 0',
      },
      saved: '已保存 {{time}}',
      sections: {
        basics: '基本信息',
        items: '货物项 · {{count}}',
        dictionarySelections: '路线和包装',
        files: '文件和照片',
      },
      containerTotals: {
        section: '重量和尺寸',
        weight: '重量（千克）',
        volume: '体积（立方米）',
      },
      standardTotals: {
        section: '重量和尺寸',
        weight: '重量（千克）',
        volume: '体积（立方米）',
      },
      table: {
        brand: '品牌',
        description: '说明',
        material: '材质',
        name: '名称',
        photo: '照片',
        quantity: '件数',
        placesCount: '件数',
        productQuantity: '产品数量',
        volume: '体积，m³',
        weight: '重量，kg',
      },
      packages: {
        toggle: '录入尺寸和件数',
        addPlace: '添加件数',
        removePlace: '删除件',
        place: '第 {{index}} 件',
        widthCm: '宽度，cm',
        depthCm: '深度，cm',
        heightCm: '高度，cm',
        weightKg: '单件重量，kg',
        count: '件数',
        perPackageVolume: '单件体积，m³',
        rowVolume: '行体积，m³',
        itemTotal: '货物项合计',
        itemTotalWeight: '重量：{{value}} kg',
        itemTotalVolume: '体积：{{value}} m³',
        itemTotalQuantity: '件数：{{value}}',
        hint: '货物项的重量和体积将根据件数列表自动计算。',
        emptyPlaces: '请至少添加一件',
        mobileSummary: '{{w}} × {{d}} × {{h}} cm · {{weight}} kg · {{count}} 件',
      },
      boxes: {
        sectionTitle: '箱子',
        emptyHint: '可在此处添加含嵌套货物项的箱子。',
        addBox: '添加箱子',
        removeBox: '删除箱子',
        boxLabel: '箱子 {{index}}',
        count: '数量',
        weightKg: '单箱重量，kg',
        volumeM3: '单箱体积，m³',
        volumeMode: '体积模式',
        modeDirect: '直接输入',
        modeDimensions: '按尺寸',
        widthCm: '宽度，cm',
        depthCm: '深度，cm',
        heightCm: '高度，cm',
        contents: '箱内物品',
        contentsEmpty: '为空，请添加货物项。',
        addItem: '添加货物项',
        removeItem: '删除货物项',
        itemName: '名称',
        itemBrand: '品牌',
        itemMaterial: '材质',
        itemDescription: '描述',
        itemQuantity: '数量',
        itemPhoto: '货物项照片',
        itemPhotoMissing: '无照片',
        groups: {
          action: {
            assign: '分组',
            newGroup: '+ 新建分组',
          },
          label: {
            group: '分组 {{ordinal}}',
          },
          tooltip: {
            cannotShipTogether: '这些货物项不能一起运输',
          },
        },
      },
      titleLabel: '请求名称',
      titlePlaceholder: '例如：佛山卫浴，05/26 发货',
      toPlaceholder: '交付城市',
      returnReasonBanner: {
        title: '此请求已被物流退回',
        bodyPrefix: '原因：',
      },
    },
    containerTotalsBackfill: {
      save: '保存',
      saved: '已保存',
      error: '保存失败',
    },
    format: {
      justNow: '刚刚',
      remaining: '剩余 {{value}}',
      completedIn: '完成时长 {{value}}',
      overdue: '逾期 {{value}}',
      yesterdayAt: '昨天 {{time}}',
    },
    filters: {
      slaHot: '紧急',
      slaOverdue: '逾期',
      unread: '未读',
      kindStandard: '拼箱',
      kindContainer: '集装箱',
      kindSimple: '简单',
    },
    list: {
      all: '全部',
      columns: {
        answers: '回复',
        cargo: '货物',
        density: '密度，千克/立方米',
        manager: '经理',
        messages: '消息',
        name: '名称',
        deadlines: '期限',
        status: '状态',
        updated: '更新',
        volume: '体积',
        weight: '重量',
      },
      row: {
        containerBadge: '集装箱',
        containerDestination: '至客户地址',
        createdPrefix: '创建',
        densitySuffix: '千克/立方米',
        simpleBadge: '简单',
        updatedPrefix: '更新',
        volumeSuffix: '体积',
        weightSuffix: '重量',
      },
      answersBar: {
        tooltip: '共 {{total}} · 报价 {{tariff}} · 拒绝 {{rejected}} · 待回 {{pending}}',
      },
      empty: '没有符合筛选条件的请求',
      filters: '筛选',
      filterPanel: {
        title: '筛选',
        dateRange: '创建于',
        dateFrom: '从',
        dateTo: '至',
        weightRange: '重量 (公斤)',
        volumeRange: '体积 (立方米)',
        rangeMin: '最小',
        rangeMax: '最大',
        manager: '经理',
        managerAll: '所有经理',
        managerSelectedCount_one: '已选 {{count}} 位经理',
        managerSelectedCount_few: '已选 {{count}} 位经理',
        managerSelectedCount_many: '已选 {{count}} 位经理',
        managerSelectedCount_other: '已选 {{count}} 位经理',
        clearAdvanced: '清除高级筛选',
      },
      loadMore: '加载更多',
      loadingMore: '加载中…',
      loading: '加载中…',
      error: '加载请求失败',
      newRequest: '新建复杂请求',
      newContainer: '新建集装箱',
      newSimple: '新建简单请求',
      searchPlaceholder: '按 ID 或名称搜索',
      statusesToggle: '状态',
      title: '物流请求',
    },
    items: {
      empty: '尚未添加货物项',
    },
    photoGallery: {
      counter: '照片 {{current}} / {{total}}',
      prev: '上一张',
      next: '下一张',
      close: '关闭',
    },
    photo: {
      moreBadge: '+{{count}}',
    },
    pickWinnerModal: {
      confirm: '指定为获胜方',
      empty: '还没有承运商回复，暂时无法选择。',
      title: '选择获胜方 — {{id}}',
    },
    successModal: {
      confirm: '确认成功',
      title: '成功 — {{id}}',
      winnerText: '获胜方 —— {{name}}。',
      noBids: '本请求暂无应答的承运商。请等待应答或重新打开请求以进行新一轮询价。',
      expiredWarning: '该报价已于 {{date}} 失效。请在确认前与承运商再次确认价格。',
    },
    refuseModal: {
      confirm: '确认拒单',
      title: '拒单 — {{id}}',
      explanation: '请求将转为“拒单”状态。如已选择获胜方，将被清除。',
      reason: {
        quoteResponseTooSlow: '承运商报价响应过慢',
        priceNotAccepted: '客户未接受价格',
        clientUnresponsive: '客户失联',
        other: '其他原因',
      },
      commentLabel: '备注（可选）',
      commentPlaceholder: '供商务团队参考的拒单详情',
      commentHint: '仅团队可见，不写入审计日志',
    },
    refusalDetails: {
      reasonMissing: '未指定原因',
      title: '拒单原因',
    },
    returnModal: {
      explanation: '请求将退回到“退回”状态。经理会看到原因并进行修改。',
      presets: {
        missingDescription: '缺少商品描述：制造材料、应用领域；',
        weightVolume: '请检查重量和体积数据。',
      },
      presetsTitle: '原因模板',
      reasonLabel: '退回原因',
      reasonPlaceholder: '说明需要确认或修改的内容',
      submit: '退回给经理',
      title: '退回修改 — {{id}}',
    },
    cannotTransportModal: {
      title: '无法承运 — 申请 {{id}}',
      explanation:
        '申请将转入“无法承运”状态。这是终态：承运商和报价会保留，但经理将看到该申请在我方已关闭。',
      reasonLabel: '原因',
      reasonPlaceholder: '请说明我们为何无法承运此货物',
      submit: '标记为无法承运',
    },
    reopenModal: {
      explanation: '请求将退回到“处理中”。胜出方将被清空，SLA 重新计时，可进行新一轮物流询价。',
      reasonLabel: '重新打开原因',
      reasonPlaceholder: '说明为何需要重新进行物流询价',
      submit: '重新打开',
      title: '重新打开请求 — {{id}}',
    },
    roleSubtitle: {
      admin: '完整访问：监控、重新打开、重新分配',
      logist_cn: '你处理活动请求池并管理报价',
      manager: '你创建请求并选择获胜方',
    },
    status: {
      archive: '归档',
      closed: '已关闭',
      draft: '草稿',
      inWork: '处理中',
      processed: '已处理',
      clientDecision: '决定？',
      readyForWork: '待派工',
      return: '退回',
      success: '成功',
      refused: '拒单',
      postponed: '已搁置',
      cannotTransport: '无法承运',
    },
    store: {
      created: '请求已创建',
      defaultDraftName: '新请求（草稿）',
      returnChatPrefix: '⤴ 退回：{{reason}}',
      transition: {
        archive: '已归档',
        close: '请求已关闭',
        process: '已标记为处理完成',
        return: '已退回修改',
        send: '已发送处理',
        unarchive: '已从归档恢复',
        success: '已确认成功',
        refuse: '已确认拒单',
        postpone: '请求已搁置',
      },
      winnerSelected: '已选择获胜方：{{name}}',
    },
    tabs: {
      archive: '存档',
      archiveCount: '存档（{{count}}）',
      audit: '日志',
      auditCount: '日志（{{count}}）',
      carriers: '承运商（{{count}}）',
      chat: '聊天（{{count}}）',
      files: '文件',
      filesCount: '文件（{{count}}）',
      items: '货物项（{{count}}）',
      returnBanner: '退回修改',
    },
    archive: {
      empty: '暂无退回记录',
      returnedAt: '退回时间：{{date}}',
      backToRequest: '返回申请',
      snapshotTitle: '退回快照',
      carriersEmpty: '此快照中没有承运商',
      loadError: '无法加载存档',
    },
    table: {
      brand: '品牌',
      description: '说明',
      material: '材质',
      photos: '照片',
      quantity: '件数',
      placesCount: '件数',
      productQuantity: '产品数量',
      title: '名称',
    },
    unavailable: {
      title: '请求不可用',
    },
    files: {
      add: '添加文件',
      uploading: '上传中…',
      usage: '文件 {{count}} / {{max}}',
      saveFirst: '请先保存草稿，然后再附加文件。',
      capReached: '已达到此请求的文件数量上限。',
      empty: '尚未附加文件',
      download: '下载',
      remove: '删除',
      errors: {
        wrongType: '不支持此文件类型',
        tooLarge: '文件过大',
        uploadFailed: '上传失败 — 请重试',
        downloadFailed: '下载文件失败',
        listFailed: '无法加载文件列表',
        removeFailed: '无法删除文件',
      },
    },
  },
  cargoProblems: {
    title: '货物：问题',
    actions: {
      back: '返回',
      cancel: '取消',
      close: '关闭',
      confirm: '确认',
      create: '创建问题',
      delete: '删除',
      edit: '编辑',
      editAndResubmit: '编辑并重新提交',
      evaluate: '评估',
      claim: '领取',
      reject: '驳回',
      reassign: '更换负责人',
      retryPublish: '重试发布',
      save: '保存',
      submit: '提交',
      submitReview: '提交审核',
      publish: '报告问题',
    },
    list: {
      subtitle: '共 {{count}} 个问题',
      empty: '没有符合筛选条件的问题',
      capped: '仅显示前 300 个问题。',
      columns: {
        attention: '关注',
        cargo: '货物',
        category: '类别',
        description: '描述',
        status: '状态',
        assignee: '负责人',
        updatedAt: '更新时间',
        tariff: '运价',
        dimensions: '重量 / 体积',
        carrier: '承运商',
      },
    },
    filters: {
      toggle: '筛选',
      search: '搜索',
      searchPlaceholder: '描述、评论、货号或名称',
      status: '状态',
      category: '类别',
      queue: '队列',
      author: '创建人',
      assignee: '负责人',
      carrier: '承运商',
      createdFrom: '创建日期从',
      createdTo: '创建日期至',
      updatedFrom: '更新日期从',
      updatedTo: '更新日期至',
      overdueOnly: '仅显示超时响应',
    },
    statuses: {
      DRAFT: '草稿',
      NEW: '新问题',
      REJECTED: '已驳回',
      IN_PROGRESS: '处理中',
      REVIEW: '审核中',
      NOT_RESOLVED: '未解决',
      PARTIALLY_RESOLVED: '部分解决',
      RESOLVED: '已解决',
    },
    categories: {
      SUPPLIER: '供应商',
      CHINA_WAREHOUSE: '中国仓库',
      CHINA_CARRIER: '中国承运商',
      RUSSIA_WAREHOUSE: '俄罗斯仓库',
      RUSSIA_CARRIER: '俄罗斯承运商',
    },
    queues: { CHINA_LOGISTICS: '中国物流', RUSSIA_LOGISTICS: '俄罗斯物流' },
    events: {
      SUBMITTED: '问题已提交',
      REJECTED: '问题已驳回',
      CLAIMED: '问题已领取',
      REVIEW_SUBMITTED: '解决方案已提交审核',
      EVALUATED: '解决方案已评估',
      EDITED: '问题已编辑',
      RESUBMITTED: '问题已重新提交',
      COMMENT_ADDED: '已添加评论',
      FILE_UPLOADED: '已附加文件',
      ASSIGNEE_CHANGED: '已更改负责人',
      ATTACHMENT_DELETED: '已删除附件',
    },
    summary: {
      label: '问题汇总计数',
      status: '状态',
      category: '类别',
      queue: '队列',
    },
    editor: {
      editEyebrow: '编辑问题',
      createEyebrow: '新问题',
      newTitle: '问题草稿',
      cargo: '货物',
      cargoSearch: '输入货号或名称',
      category: '类别',
      queue: '队列',
      description: '简要描述发生的情况',
      contextSection: '货物信息',
      briefSection: '问题说明',
      ownershipSection: '方向与负责人',
      attachmentsSection: '初始材料',
      attachments: '附件',
      assignee: '负责人',
      assigneePlaceholder: '选择有效负责人',
      assigneeUnavailable: '不可用',
      assigneeUnavailableHelp: '此人员已不符合分配条件，请选择有效负责人。',
      privateDraft: '草稿已保存；发布前仅您可见。',
      privateDraftRetry: '发布失败。私有草稿和已就绪文件均已保留，可重试。',
    },
    validation: {
      cargoRequired: '请选择货物',
      categoryRequired: '请选择类别',
      queueRequired: '请选择队列',
      descriptionRequired: '请输入描述',
      assigneeRequired: '请选择有效负责人',
      noteRequired: '请输入评论',
      outcomeRequired: '请选择结果',
    },
    detail: {
      problem: '问题',
      summary: '问题摘要',
      provenance: '详细信息',
      workCard: '当前工作',
      briefMaterials: '初始材料',
      terminalReadOnly: '此问题已完成。工作卡和历史记录为只读。',
      category: '类别',
      queue: '队列',
      author: '创建人',
      assignee: '负责人',
      createdAt: '创建时间',
      updatedAt: '更新时间',
      reactionDueAt: '响应截止',
      notApplicable: '不适用',
      description: '描述',
      cargo: '货物',
      openCargo: '在货物登记中打开 {{cargo}}',
      outcome: '结果',
    },
    timeline: {
      title: '技术历史',
      empty: '暂无历史记录',
      hint: '仅记录状态、负责人与材料删除等流程事件。',
    },
    workspace: {
      conversation: '沟通',
      materials: '材料',
      loadOlder: '显示更早的消息',
      empty: '暂无消息',
      conversationError: '无法加载沟通记录。',
      retry: '重试',
      actionRequired: '需要处理',
      systemCard: '流程事件',
      assigneeChange: '{{from}} → {{to}}',
      attachmentDeleted: '附件已删除。原因：{{reason}}',
    },
    message: {
      label: '消息',
      placeholder: '输入消息',
      send: '发送',
      sent: '消息已发送',
      reply: '回复',
      replyingTo: '回复：{{author}}',
      cancelReply: '取消回复',
      replyUnavailable: '原消息不可用',
      documentNeedsText: '请为文档补充简短说明',
      attachmentsPending: '请等待附件上传完成',
      empty: '请输入消息或添加附件',
      tooLong: '消息超过 {{max}} 个字符',
    },
    attachments: {
      add: '添加附件',
      remove: '移除 {{name}}',
      retry: '重新上传 {{name}}',
      statusUploading: '{{name}}：上传中',
      statusReady: '{{name}}：已就绪',
      statusError: '{{name}}：上传失败',
      previous: '上一个文件',
      next: '下一个文件',
      download: '下载',
      noPreview: '该文件类型无法预览',
      previewError: '无法打开文件',
    },
    library: {
      title: '材料',
      search: '按文件名搜索',
      empty: '暂无材料',
      filters: { ALL: '全部', MEDIA: '媒体', DOCUMENTS: '文档' },
      error: '无法加载材料。',
      jump: '在沟通中查看',
      jumpBrief: '在初始申请中查看',
      brief: '初始申请',
      delete: '删除材料',
      deleteTitle: '删除该材料？',
      deleteText: '所有参与者将无法再打开该文件，并会看到删除原因。',
      deleteReason: '删除原因',
      deleted: '材料已删除',
      uploadedBy: '{{author}} · {{date}}',
    },
    files: {
      attach: '附加文件',
      uploading: '上传中…',
      uploaded: '文件已附加',
      selected: '已选择 {{count}} 个',
      selectedList: '已选附件',
      remove: '移除 {{name}}',
      errors: {
        count: '最多可附加 10 个文件',
        type: '不支持此文件类型',
        size: '文件过大',
        name: '文件名过长',
        upload: '无法附加文件',
      },
    },
    toasts: {
      created: '问题草稿已创建',
      published: '问题已发布',
      resubmitted: '问题已编辑并重新提交',
      saved: '更改已保存',
      transitioned: '问题状态已更新',
      reassigned: '负责人已更改',
      deleted: '问题草稿已删除',
    },
    reassign: {
      title: '更改负责人',
      current: '当前负责人',
      currentUnavailableHelp: '当前负责人已不再符合此队列的分配条件。请选择可用员工。',
      next: '新负责人',
      loadError: '无法加载可选员工。',
      slaHelp: '重新分配后，响应时限将重新开始。',
    },
    noteTitles: {
      label: '评论',
      reject: '驳回原因',
      submitReview: '解决方案描述',
      evaluate: '解决方案评估',
    },
    delete: { title: '删除草稿？', text: '草稿及其历史记录将被永久删除。' },
    dimensions: { weight: '重量', volume: '体积' },
    cargoUnavailable: '货物数据已不可用',
    unassigned: '未分配',
    overdue: '已超时',
  },
  cargo: {
    title: '货物',
    loading: '加载中…',
    error: '无法加载货物',
    empty: '暂无货物',
    actions: {
      import: '导入',
      add: '添加',
      filters: '筛选',
      resetFilters: '重置',
      delete: '删除货物',
      reportProblem: '报告问题',
      createTtn: '创建运单',
    },
    ttnInternalCosts: {
      chinaPayment: '中国付款',
      warehouseDispatch: '中国仓库发货',
      warehouseInspection: '中国仓库验货',
      warehousePackaging: '中国仓库打包',
    },
    mirror: {
      banner: '只读镜像模式：迁移期间 NextKargo 为数据来源，编辑功能已禁用。',
    },
    list: {
      searchPlaceholder: '按货号搜索',
      loadMore: '加载更多',
      loadingMore: '加载中…',
    },
    filters: {
      all: '全部',
      status: '状态',
      manager: '负责人',
      carrier: '承运商',
      carrierPlaceholder: '精确名称',
      pathFormat: '路线',
      clientPaymentStatus: '客户付款',
      carrierPaymentStatus: '承运商付款',
      weightRange: '重量（千克）',
      volumeRange: '体积（立方米）',
      totalCostRange: '总费用',
      rangeFrom: '从',
      rangeTo: '至',
      dateType: '日期类型',
      dateFrom: '起始日期',
      dateTo: '结束日期',
      overdue: '逾期',
      hasRejectedDocument: '已拒绝单据',
      hasRejectedDocumentHint: '含已拒绝单据',
    },
    lifecycle: {
      in_transit: '在途',
      arrived_not_issued: '已抵俄罗斯',
      issued: '已放货',
    },
    activeFilters: {
      search: '搜索',
      dateRange: '{{range}}',
      from: '从 {{value}}',
      to: '至 {{value}}',
      clear: '清除筛选「{{label}}」',
    },
    dateTypes: {
      china_ship: '中国发货日期',
      arrival: '到达日期',
      issue: '放货日期',
    },
    overdue: {
      '1plus': '1天以上',
      '7plus': '7天以上',
    },
    status: {
      issued: '已放货',
    },
    cells: {
      noManager: '无负责人',
      deleteDisabled: '删除（即将推出）',
    },
    tariff: {
      saved: '运费已保存',
    },
    delete: {
      title: '删除货物',
      text: '删除货物“{{article}}”？之后可恢复。',
      toast: '货物已删除',
    },
    forms: {
      addTitle: '新建货物',
      editTitle: '货物“{{article}}”',
      unset: '未设置',
      fields: {
        article: '货号',
        manager: '负责人',
        carrier: '承运商',
        pathFormat: '路线',
        status: '状态',
        nameGoods: '商品',
        numberOfSeats: '件数',
        weight: '重量（千克）',
        volume: '体积（立方米）',
        transportationTariff: '运费',
        transportationTariffForClients: '客户运输运费',
        costGoods: '商品价格',
        insuranceCost: '保险价格',
        packagingCost: '包装价格',
        timeFromChina: '中国发货日期',
        totalCost: '运输总费用',
        addressTransportationCost: '地址配送',
        chinaPaymentAmount: '中国收货',
        chinaWarehouseDispatchAmount: '仓库发货，中国',
        chinaWarehouseInspectionAmount: '仓库验货，中国',
        chinaWarehousePackagingAmount: '仓库打包，中国',
        prr: '装卸费',
        tatCost: 'TAT 付款',
        paymentToCarrierStatus: '已付承运商',
        timeCargoArrivalToRf: '货物到达俄罗斯日期',
        timeCargoRelease: '货物放货日期',
      },
      errors: {
        required: '必填项',
        numeric: '请输入数字',
        releaseDateRequired: '请填写放货日期',
      },
      toasts: {
        created: '货物已创建',
        updated: '货物已更新',
      },
    },
    import: {
      title: '导入货物',
      format: '格式',
      pickFiles: '选择文件',
      process: '上传',
      processing: '处理中…',
      removeFile: '移除文件',
      fileLabel: '文件 {{index}}',
      buckets: {
        created: '已创建',
        updated: '已更新',
        warnings: '警告',
        errors: '错误',
      },
      errors: {
        wrongExtension: '仅允许 .xlsx 和 .xls 文件',
        tooLarge: '文件超过 50 MB',
        nameTooLong: '文件名过长',
        tooManyFiles: '每次导入最多 {{max}} 个文件',
      },
      toasts: {
        processed: '导入已处理',
      },
    },
    payment: {
      title: '客户已付款 — {{article}}',
      statusLabel: '付款状态',
      noDocumentWarning: '请至少附加一个文件以保存状态。',
      save: '保存状态',
      toasts: {
        statusSaved: '付款状态已保存',
      },
      docCounts: '已拒绝：{{rejected}}，待审核：{{pending}}，已接受：{{accepted}}',
      rejectedMarker: '存在被拒绝的文件',
      manager: {
        desiredStatusLabel: '期望状态',
        desiredStatusPlaceholder: '选择状态…',
        options: {
          paid: '已付款',
          partially_paid: '部分付款',
        },
        submit: '提交审核',
        submitHint: '需要至少一个文件并选择状态。',
        lockedHint: '状态已由审核确定。请修改文件以重新开启审核。',
        toasts: {
          submitted: '已提交审核',
        },
      },
      review: {
        decisionLabel: '决定',
        decision: {
          pending: '未审核',
          accepted: '接受',
          rejected: '拒绝',
        },
        currencyLabel: '货币',
        receivedRubLabel: '已收，₽',
        foreignAmountLabel: '外币金额',
        exchangeRateLabel: '汇率',
        rubPreviewLabel: '计算，₽',
        total: '已接受合计：{{amount}}',
        save: '保存决定',
        invalidAmount: '请按 1234.56 的格式输入金额。',
        toasts: {
          saved: '决定已保存',
        },
      },
      errors: {
        reviewNotOpen: '该货物的审核已关闭。请刷新页面。',
        reviewIncomplete: '并非所有文件都已审核。',
        documentLocked: '该文件已确定，无法修改。',
        documentUnknown: '未找到文件。请刷新页面。',
        noActiveDocument: '没有可审核的有效文件。',
      },
      documents: {
        title: '付款文件',
        empty: '暂无文件',
        error: '无法加载文件',
        download: '下载',
        upload: '附加文件',
        uploading: '上传中…',
        uploaderDeleted: '用户已删除',
        reviewStatus: {
          pending: '未审核',
          accepted: '已接受',
          rejected: '已拒绝',
        },
        confirmDelete: {
          title: '删除文件',
          text: '删除文件“{{name}}”？',
        },
        toasts: {
          uploaded: '文件已附加',
          deleted: '文件已删除',
        },
        errors: {
          wrongType: '不支持的文件类型',
          tooLarge: '文件超过 25 MB',
          nameTooLong: '文件名过长',
        },
      },
    },
    summary: {
      error: '无法加载汇总',
    },
    totals: {
      count: '数量',
      totalWeightKg: '重量（千克）',
      totalVolumeM3: '体积（立方米）',
      totalPrr: '装卸费',
      totalTat: 'TAT 付款',
      totalChinaPayment: '中国收货',
      totalChinaWarehouseAmount: '仓库合计，中国',
    },
    indicators: {
      paidNotIssued: '已付款未放货',
      missingResponsibleManager: '无负责人',
      missingPathFormat: '无路线',
      noInsurance: '无保险',
      rejectedDocument: '已拒绝单据',
      copy: '复制货号',
    },
    statistics: {
      toggle: '统计',
      loading: '正在加载统计…',
      error: '无法加载统计',
      noData: '暂无数据',
      clientPaymentStatus: {
        not_paid: '未付款',
        partially_paid: '部分付款',
        paid: '已全额付款',
        under_review: '审核中',
      },
      kpi: {
        count: '货物总数',
        inTransit: '在途',
        arrivedNotIssued: '已到达未放货',
        issued: '已放货',
        withoutManager: '无负责人',
        weight: '总重量（千克）',
        volume: '总体积（立方米）',
        chinaAmount: '中国金额',
        avgDaysInTransit: '平均在途天数',
      },
      delta: {
        increased: '增长 {{percent}}%',
        decreased: '下降 {{percent}}%',
        flat: '无变化',
      },
      sections: {
        lifecycle: '阶段',
        indicators: '指标',
        totals: '合计',
        payments: '付款',
        carriers: '承运商',
        managers: '负责人',
        monthly: '月度趋势',
        distribution: '分布',
        money: '月度金额',
        ratings: '排行',
        routes: '路线',
      },
      lifecycle: {
        total: '总计',
        inTransit: '在途',
        arrivedNotIssued: '已到达未放货',
        issued: '已放货',
        withoutManager: '无负责人',
      },
      payments: {
        client: '客户付款',
        carrier: '承运商付款',
      },
      carriers: {
        carrier: '承运商',
        count: '数量',
        weight: '重量（千克）',
        volume: '体积（立方米）',
      },
      managers: {
        manager: '负责人',
        unassigned: '无负责人',
        count: '数量',
        weight: '重量（千克）',
        volume: '体积（立方米）',
        inTransit: '在途',
        arrivedNotIssued: '已到达未放货',
        issued: '已放货',
      },
      monthly: {
        month: '月份',
        count: '数量',
      },
      pies: {
        clientPayments: '客户付款',
        carriers: '承运商',
        lifecycle: '阶段',
        other: '其他',
        status: '状态',
        stage: '阶段',
        count: '数量',
        empty: '暂无数据',
      },
      money: {
        title: '中国金额，¥',
        month: '月份',
        aria: '按月中国金额',
      },
      ratings: {
        managers: '负责人排行',
        carriers: '承运商排行',
        avgDaysInTransit: '平均在途天数',
        count: '数量',
      },
      routes: {
        route: '路线',
        none: '无路线',
        count: '数量',
        countAria: '按路线货物',
        share: '路线占比',
      },
      presets: {
        thisMonth: '本月',
        last30: '最近30天',
        quarter: '本季度',
        ytd: '今年至今',
      },
    },
    columns: {
      article: '货号',
      totalCost: '运输总费用',
      daysWithoutPayment: '未付款天数',
      manager: '负责人',
      carrier: '承运商',
      pathFormat: '路线',
      status: '状态',
      nameGoods: '商品',
      numberOfSeats: '件数',
      weight: '重量（千克）',
      volume: '体积（立方米）',
      density: '密度（千克/立方米）',
      transportationTariff: '运费',
      transportationTariffForClients: '客户运输运费',
      costGoods: '商品价格',
      insuranceCost: '保险价格',
      packagingCost: '包装价格',
      timeFromChina: '中国发货日期',
      chinaPayment: '中国收货',
      chinaWarehouseDispatch: '仓库发货，中国',
      chinaWarehouseInspection: '仓库验货，中国',
      chinaWarehousePackaging: '仓库打包，中国',
      chinaWarehouseTotal: '合计，中国',
      addressTransportationCost: '地址配送',
      prr: '装卸费',
      tatCost: 'TAT 付款',
      clientPaymentStatus: '客户已付款',
      carrierPaymentStatus: '已付承运商',
      timeCargoArrivalToRf: '货物到达俄罗斯日期',
      timeCargoRelease: '货物放货日期',
      daysOnTheWay: '在途天数',
      delete: '删除',
    },
  },
  russiaRequests: {
    title: '俄罗斯请求',
    empty: '暂无请求',
    loading: '加载中…',
    error: '加载请求失败',
    actions: {
      newSimple: '简单',
      newComplex: '复杂',
      duplicate: '复制',
      send: '发送',
      return: '退回',
      process: '标记已处理',
      reopen: '重新打开',
      close: '关闭',
      success: '成功',
      refuse: '拒绝',
      postpone: '搁置',
      archive: '归档',
      unarchive: '取消归档',
    },
    list: {
      searchPlaceholder: '按名称或编号搜索',
      loadMore: '加载更多',
      loadingMore: '加载中…',
    },
    filters: {
      status: '状态',
      type: '类型',
      manager: '经理',
      all: '全部',
    },
    columns: {
      id: '编号',
      type: '类型',
      status: '状态',
      name: '名称',
      manager: '经理',
      startCities: '出发城市',
      endAddress: '送货地址',
      primaryBidSummary: '主要报价',
      primaryBidEmpty: '—',
      primaryBidAwaiting: '等待报价',
      primaryBidDays: '{{count}} 天',
      primaryBidDaysRange: '{{min}}–{{max}} 天',
      createdAt: '创建于',
    },
    startCities: {
      empty: '—',
      more: '+{{count}}',
    },
    types: {
      lead: '潜在',
      warehouse: '从仓库',
      inTransit: '在途',
      urgent: '紧急',
    },
    editor: {
      title: '新建俄罗斯请求',
      editTitle: '编辑请求',
      cancel: '取消',
      save: '创建',
      saving: '创建中…',
      editSave: '保存',
      editSaving: '保存中…',
      submitError: '创建失败，请检查字段后重试。',
      cards: {
        basics: '基本信息',
        endAddress: '送货地址',
        startCities: '始发城市',
      },
      fields: {
        type: '类型',
        name: '名称',
        endAddress: '送货地址',
        startCities: '始发城市',
      },
      errors: {
        nameRequired: '请输入名称',
        endAddressRequired: '请输入送货地址',
      },
      autosave: {
        saving: '保存中…',
        savedAt: '已于 {{time}} 保存',
        error: '无法保存草稿',
      },
      startCities: {
        empty: '尚未选择始发城市',
        pickerPlaceholder: '选择城市…',
        add: '添加',
        remove: '移除 {{name}}',
      },
      positions: {
        title: '货物明细',
        empty: '暂无货物明细',
        add: '添加货物明细',
        newPosition: '新货物明细',
        fields: {
          name: '名称',
          brand: '品牌',
          material: '材料',
          description: '描述',
          weightKg: '重量，千克',
          volumeM3: '体积，立方米',
          quantity: '件数',
          productQuantity: '商品数量',
          photos: '照片',
        },
      },
      totals: {
        title: '重量和尺寸',
        weight: '重量（千克）',
        volume: '体积（立方米）',
      },
      files: {
        title: '文件',
        add: '添加文件',
        uploading: '上传中…',
        usage: '文件 {{count}} / {{max}}',
        capReached: '已达到此请求的文件数量上限。',
        empty: '尚未附加文件',
        download: '下载',
        remove: '删除',
        errors: {
          wrongType: '不支持此文件类型',
          tooLarge: '文件过大',
          uploadFailed: '上传失败 — 请重试',
          listFailed: '无法加载文件列表',
          removeFailed: '无法删除文件',
        },
      },
    },
    drawer: {
      close: '关闭',
      editDraft: '补全草稿',
      unavailable: {
        title: '请求不可用',
      },
      tabsComingSoon: '此选项卡将在 #706 的后续切片中提供。',
      parentLink: '← 中国 #{{id}}',
      transitionError: '无法更改状态，请重试。',
      sendReadiness: {
        title: '请求尚未准备好发送',
        missingEndAddress: '请填写送货地址。',
        missingTotals: '请填写货物的总重量和总体积。',
        missingItems: '请至少添加一条包含名称、描述、重量和体积的完整货物明细。',
      },
      returnBanner: {
        title: '已退回修改',
        body: '需要操作：检查后重新发送。',
      },
      confirm: {
        close: {
          title: '关闭请求？',
          text: '关闭后将完成此请求，除管理员重新打开外无法撤销。',
        },
        archive: {
          title: '归档请求？',
          text: '归档后将从默认列表中隐藏此请求。稍后可取消归档。',
        },
        success: {
          title: '标记为成功？',
          text: '请求将按所选中标报价标记为成功。请先在承运商标签页选择中标方再完成。',
        },
        refuse: {
          title: '记录拒绝？',
          text: '请求将作为客户拒绝而关闭。稍后可补充详细原因。',
        },
      },
      reason: {
        return: {
          title: '退回到草稿',
          text: '简要说明需要修改的内容。',
        },
        reopen: {
          title: '重新打开请求',
          text: '简要说明处理后需要修改的内容。',
        },
      },
      info: {
        managerId: '经理（ID）',
      },
      header: {
        createdAt: '创建于 {{date}}',
        emptyAddress: '—',
      },
      tabs: {
        cargo: '货物',
        cost: '费用',
        chat: '聊天',
      },
      cargo: {
        section: {
          body: '货物',
        },
        totals: {
          weightKg: '总重量（千克）',
          volumeM3: '总体积（立方米）',
          quantity: '总件数',
        },
        files: {
          empty: '暂无文件',
          error: '加载文件失败',
          columns: {
            name: '名称',
            size: '大小',
          },
        },
      },
      cost: {
        readonly: {
          empty: '暂无费用',
          price: '费用',
          validityDays: '有效期（天）',
          expiresAt: '到期',
          expired: '已过期',
        },
      },
      items: {
        empty: '暂无物品',
        columns: {
          name: '名称',
          description: '描述',
          brand: '品牌',
          material: '材质',
          productQuantity: '货物数量',
          quantity: '件数',
          weightKg: '重量（千克）',
          volumeM3: '体积（立方米）',
          photos: '照片',
        },
      },
      boxes: {
        empty: '暂无箱子',
        columns: {
          count: '数量',
          weightKg: '重量（千克）',
          volumeM3: '体积（立方米）',
        },
      },
      audit: {
        empty: '暂无审计记录',
        error: '审计加载失败',
        columns: {
          at: '时间',
          action: '操作',
          actor: '操作者',
          transition: '状态变更',
        },
        actions: {
          CREATE: '创建',
          UPDATE: '更新',
          DELETE: '删除',
          TRANSITION_SEND: '发送给物流',
          TRANSITION_AUTO_START: '自动进入处理中',
          TRANSITION_RETURN: '退回经理',
          TRANSITION_PROCESS: '已处理',
          TRANSITION_REOPEN: '重新打开',
          TRANSITION_CLOSE: '关闭',
          TRANSITION_SUCCESS: '成功完成',
          TRANSITION_REFUSE: '客户拒绝',
          TRANSITION_POSTPONE: '请求已搁置',
          WINNER_PICK: '已选择中标方',
          TRANSITION_ARCHIVE: '归档',
          TRANSITION_UNARCHIVE: '取消归档',
          CHAT_POSTED: '聊天消息已发送',
          CHAT_MARKED_UNREAD: '聊天标记为未读',
          CHAT_UNMARKED: '已取消未读标记',
        },
      },
      carriers: {
        empty: '尚未指派承运人',
        error: '承运人加载失败',
        unitSuffix: {
          total: '',
          kg: '/千克',
          m3: '/立方米',
          piece: '/件',
        },
        states: {
          PENDING: '等待回复',
          ANSWERED: '已回复',
          REJECTED: '已拒绝',
        },
        add: {
          modalTitle: '添加承运人',
          trigger: '添加承运人',
          submit: '添加',
          modeInline: '新建',
          modeFromCatalog: '从目录选择',
          nameLabel: '承运人名称',
          contactsLabel: '联系方式',
          catalogPlaceholder: '从目录中选择承运人…',
          catalogError: '加载承运人目录失败',
          notFound: '未找到该承运人或承运人已停用',
          invalidStatus: '仅在「进行中」状态下可添加承运人',
          generic: '添加承运人失败',
        },
        bid: {
          priceLabel: '价格',
          validityDaysLabel: '有效期（天）',
          commentLabel: '备注',
          submit: '保存报价',
          invalidStatus: '仅在「进行中」状态下可添加报价',
          notFound: '未找到该承运人',
          generic: '保存报价失败',
        },
        bidModal: {
          titlePrimary: '报价 · {{name}}',
        },
        actions: {
          editCarrier: '编辑',
          deleteCarrier: '删除',
          editBid: '编辑报价',
          deleteBid: '删除报价',
          menuAria: '操作',
        },
        editCarrier: {
          title: '编辑承运商 {{code}}',
          submit: '保存',
          invalidStatus: '仅在「进行中」状态下可以编辑',
          notFound: '未找到该承运人',
          generic: '保存修改失败',
        },
        editBid: {
          title: '编辑报价',
        },
        deleteCarrier: {
          confirmTitle: '删除选项 {{code}}？',
          confirmBody: '该承运商的所有报价将被删除，操作不可恢复。',
        },
        deleteBid: {
          confirmTitle: '删除报价？',
          confirmBody: '操作不可恢复。',
        },
        card: {
          addPrimary: '添加报价',
          addedAt: '添加于 {{date}}',
          contactsHeading: '联系方式',
          daysLeft: '剩余 {{days}} 天',
          expiresToday: '今日到期',
          expired: '已过期',
        },
        section: {
          bestOffers: '承运人',
          completedCount: '已响应 {{completed}} / {{total}}',
        },
        winner: {
          pick: '选为中标方',
          badge: '中标',
        },
        perCity: {
          heading: '按发货城市的报价',
          noRate: '尚无报价',
          addRate: '添加报价 · {{carrier}}',
          editRate: '编辑',
        },
      },
    },
    chat: {
      empty: '暂无消息',
      placeholder: '以 {{name}} 身份回复…',
      send: '发送',
      newDivider: '新消息',
      markUnread: '标记为未读',
      unmarkUnread: '取消未读',
      aria: {
        sent: '已发送',
        read: '对方已读',
      },
    },
  },
  commercialProposals: {
    title: '商业报价',
    empty: '暂无商业报价',
    loading: '加载中…',
    error: '加载商业报价失败',
    actions: {
      create: '新建报价',
      edit: '编辑',
      preview: '预览',
      publish: '发布',
      publishing: '发布中…',
      revoke: '撤回发布',
      revoking: '撤回中…',
      copyLink: '复制公开链接',
      copyLinkDone: '链接已复制',
      copyLinkError: '复制链接失败',
      downloadPdf: '下载 PDF',
      downloadError: '下载 PDF 失败',
    },
    columns: {
      publicCode: '编号',
      client: '客户',
      productName: '产品',
      status: '状态',
      owner: '所有者',
      htmlViews: '浏览量',
      updatedAt: '更新时间',
    },
    status: {
      draft: '草稿',
      published: '已发布',
    },
    editor: {
      title: '新建报价',
      editTitle: '编辑报价',
      cancel: '取消',
      create: '创建草稿',
      creating: '创建中…',
      createError: '创建报价失败。请检查字段后重试。',
      save: '保存',
      saving: '保存中…',
      saveError: '保存报价失败。请检查字段后重试。',
      publishedLocked: '已发布的报价为只读。请先撤回为草稿后再修改。',
      characteristicsHint: '每行一个特性',
      groups: {
        header: '抬头与汇率',
        product: '产品',
        buyout: '采购',
        logistics: '物流',
        totals: '合计',
        advanced: '换算系数',
        notes: '备注',
        manager: '经理',
      },
      fields: {
        mode: '报价构成',
        client: '收件人 / 客户',
        productName: '产品名称',
        proposalDate: '日期',
        cnyRateRub: '人民币汇率（₽/1元）',
        usdRateRub: '美元汇率（₽/1美元）',
        buyoutTotalCurrency: '采购合计币种',
        logisticsTotalCurrency: '物流合计币种',
        grandTotalCurrency: '总计币种',
        characteristics: '特性',
        buyoutTerm: '采购周期',
        goodsCny: '货物成本（¥）',
        chinaDeliveryCny: '中国境内运费（¥）',
        paymentScheme: '付款方式',
        destination: '目的地',
        logisticsTerm: '物流周期',
        places: '件数',
        weightKg: '重量（公斤）',
        volumeM3: '体积（立方米）',
        tariffUsd: '运费（$）',
        tariffUnit: '运费单位',
        packagingUsd: '包装（$）',
        prrUsd: '装卸（$）',
        servicePercent: '全包服务（%）',
        noVatDivisor: '无增值税 %',
        vatDivisor: '增值税 %',
        insurancePercent: '保险（%）',
        insuranceCnyPerUsdRate: '保险用人民币/美元汇率',
        buyoutNotes: '备注 — 采购',
        logisticsNotes: '备注 — 物流',
        managerName: '姓名',
        managerPhone: '电话',
        photo: '产品照片',
      },
      photo: {
        upload: '上传照片',
        replace: '替换照片',
        clear: '删除照片',
        uploading: '上传中…',
        alt: '产品照片',
        fromClipboard: '从剪贴板添加照片',
        errors: {
          tooLarge: '文件过大。最大 10 MB。',
          wrongType: '不支持 SVG 图像。',
          decodeFailed: '浏览器无法解码此图像格式：{{format}}。',
          encodeFailed: '浏览器无法准备此图像以上传。',
          uploadFailed: '照片上传失败，请重试。',
          unsupported: '浏览器不支持读取剪贴板。',
          denied: '剪贴板访问被拒绝。',
          empty: '剪贴板中未找到受支持的图像。',
          unsupportedType: '不支持的图像类型。',
          failed: '无法从剪贴板读取图像。',
        },
      },
      paymentScheme: {
        vat: '对公账户，含增值税 + UPD',
        novat: '对公账户，无增值税 + UPD',
        cash: '现金',
        crypto: '加密货币',
        card: '银行卡',
      },
      mode: {
        both: '采购 + 物流',
        buyout: '采购',
        logistics: '物流',
      },
      tariffUnit: { kg: '每公斤', m3: '每立方米' },
    },
    calc: {
      title: '计算',
      previewNote: '预览计算。最终数值以服务器保存为准。',
      backendNote: '服务器计算',
      unavailable: '无法计算 — 请检查汇率与除数（必须大于零）。',
      serviceCny: '全包服务',
      totalCny: '人民币合计',
      buyRub: '采购（₽）',
      transportUsd: '运输',
      insuranceUsd: '保险',
      logisticsUsd: '物流（合计）',
      logisticsRub: '物流（₽）',
      grandTotal: '合计：采购 + 运输',
      params: {
        title: '计算参数',
        appliedMarkup: '应用百分比',
        noMarkup: '不适用加价',
      },
    },
    drawer: {
      loading: '加载中…',
      error: '加载报价失败',
      ownerYou: '我',
      previewTitle: '报价预览',
      fields: {
        publicCode: '编号',
        status: '状态',
        client: '客户',
        productName: '产品',
        owner: '所有者',
        htmlViews: '页面浏览量',
        pdfDownloads: 'PDF 下载量',
        updatedAt: '更新时间',
        publishedAt: '发布时间',
        photo: '产品照片',
      },
    },
  },
  commercialProposalsPublic: {
    title: '商业报价',
    loading: '加载中…',
    notFound: {
      title: '页面不可用',
      body: '链接无效或已过期。',
    },
    characteristics: '产品规格',
    photoAlt: '产品照片',
    downloadPdf: '下载 PDF',
    downloadError: 'PDF 下载失败，请重试。',
    fields: {
      proposalDate: '日期',
      client: '致',
      cnyRate: '人民币汇率',
      usdRate: '美元汇率',
    },
    totals: {
      buy: '采购',
      logistics: '物流',
      grand: '合计',
    },
  },
  agent: {
    title: '智能体',
    newConversation: '新对话',
    chat: {
      empty: '向分析智能体提问以开始。',
      thinking: '思考中…',
    },
    history: {
      title: '对话',
      regionLabel: '智能体对话历史',
      loading: '正在加载对话…',
      empty: '暂无已保存对话。',
      untitled: '未命名',
      loadFailed: '无法加载对话历史',
      openFailed: '无法打开对话',
    },
    composer: {
      questionLabel: '问题',
      placeholder: '咨询需求、营收、转化率…',
      periodLabel: '时间段',
      periodAny: '任意时间段',
      periods: {
        today: '今天',
        last7d: '最近 7 天',
        month: '本月',
        quarter: '季度',
      },
      send: '发送',
      errorRequired: '请输入问题。',
      errorTooLong: '问题过长。',
    },
    progress: {
      running: '进行中',
      done: '完成',
    },
    verdict: {
      showBasis: '显示依据',
      hideBasis: '隐藏依据',
      basisLabel: '依据',
      candidateLabel: '候选 {{n}}',
      outcome: {
        agreed: '来源一致',
        reconciled: '已核对',
        discrepancy: '来源不一致',
      },
      confidence: {
        high: '高可信度',
        low: '低可信度',
      },
      source: {
        registry: '指标注册表',
        sql: 'SQL 查询',
      },
      task: '任务',
      taskId: '任务 ID',
      figures: '指标',
      noDataReasonLabel: '无法回答的原因',
      noDataReason: {
        unsupported_domain: '暂不支持此分析领域。',
        missing_schema: '此问题尚无已批准的架构或指标。',
        ambiguous_period: '请求的时间段不明确。',
        unsafe_columns: '该查询需要智能体未获准使用的列。',
        too_broad: '问题过宽，无法用一个安全查询回答。',
        query_rejected: '生成的 SQL 查询被安全规则拦截。',
        query_timeout: '数据库查询超时。',
        missing_figure: '查询未返回必需指标。',
        non_numeric_figure: '必需指标不是数字。',
        too_many_tasks: '请求被拆分为过多任务。',
        too_many_rows: '查询返回的行数过多，无法安全显示。',
      },
      metric: '指标',
      sql: 'SQL',
      period: '时间段',
      filters: '筛选',
      values: '数值',
    },
    artifacts: {
      title: '产出',
      regionLabel: '智能体产出',
      empty: '智能体生成的产出将显示在此处。',
      received: '已收到产出',
      unsupported: '暂不支持此类工件',
      pin: '固定',
      pinning: '正在固定…',
      pinned: '产出已固定到我的仪表板。',
      pinFailed: '固定产出失败。',
      chart: {
        empty: '没有图表数据',
        dataTable: '图表数据',
        category: '类别',
        noValue: '—',
        provenance: '来源',
        createdAt: '创建时间',
        tooltip: '{{series}} · {{x}}：{{y}}',
      },
    },
    savedDashboard: {
      title: '我的仪表板',
      regionLabel: '已固定产出',
      refresh: '刷新',
      retry: '重试',
      loading: '正在加载仪表板…',
      emptyTitle: '暂无固定产出',
      empty: '从智能体回答中固定产出，以组成个人仪表板。',
      loadFailed: '加载我的仪表板失败',
      loadFailedText: '请尝试刷新页面。',
      moveUp: '上移',
      moveDown: '下移',
      unpin: '移除',
      unpinned: '产出已从我的仪表板移除。',
      unpinFailed: '移除产出失败。',
      reorderFailed: '调整顺序失败。',
    },
    error: {
      notConfigured: '分析智能体尚未配置。请联系管理员。',
      sqlRejected: '数据库查询被安全规则阻止。',
      sqlTimeout: '数据库查询超时。请缩小问题范围。',
      runFailed: '模型服务未能作答。请稍后重试。',
      generic: '智能体运行失败。请重试。',
    },
    admin: {
      title: '智能体设置',
      refresh: '刷新',
      loadFailed: '加载智能体设置失败',
      activePrompt: '当前 prompt',
      glossaryCount: '术语',
      metricCount: '指标',
      memoryState: '记忆',
      enabled: '已启用',
      disabled: '已禁用',
      catalogVersion: '目录',
      promptDraft: '业务 prompt 草稿',
      promptPlaceholder: '业务背景、智能体角色和回答风格',
      savePromptDraft: '保存草稿',
      kindGlossary: '术语',
      kindMetric: '指标',
      termPlaceholder: '名称',
      definition: '定义',
      definitionPlaceholder: '业务含义',
      addDraft: '添加草稿',
      prompts: 'Prompt 版本',
      glossary: '术语表',
      memory: '记忆',
      memoryTitlePlaceholder: '要记住的内容',
      memorySummary: '记忆摘要',
      memorySummaryPlaceholder: '用于后续回答的事实、规则或偏好',
      addMemory: '添加记忆',
      saveMemory: '保存记忆',
      edit: '编辑',
      cancel: '取消',
      activate: '启用',
      approve: '批准',
      reject: '拒绝',
      archive: '归档',
    },
  },
  dashboards: {
    chinaRequests: {
      title: '中国需求 — 概览',
      periodLabel: '周期',
      computedAt: '更新于 {{time}}',
      error: '加载概览失败',
      retry: '重试',
      periods: {
        today: '今天',
        last7d: '最近 7 天',
        month: '本月',
        quarter: '季度',
        custom: '自定义',
      },
      customFrom: '起',
      customTo: '止',
      customPrompt: '请选择开始日期和结束日期',
      kpi: {
        newRequests: '新需求',
        inWorkNow: '当前处理中',
        success: '成功',
        conversion: '转化率',
        overdueNow: '当前逾期',
        volume: '体量',
        container: '整柜',
        nonContainer: '非整柜',
        ppSuffix: ' 个百分点',
      },
      delta: {
        increased: '增长 {{value}}',
        decreased: '下降 {{value}}',
        flat: '无变化',
      },
      sla: {
        overdueNow: '逾期',
        hotNow: '紧急',
        avgProcessingDays: '平均处理天数',
        reopenCount: '重新进入处理',
        activeScopeNote: '仅统计处于“待处理”和“处理中”状态的活跃需求。已处理的需求不计为逾期。',
      },
      funnel: {
        title: '状态漏斗',
        statusHeader: '状态',
        countHeader: '数量',
      },
      trend: {
        title: '新建与关闭趋势',
        legend: {
          created: '新建',
          closed: '已关闭',
          success: '成功',
        },
        empty: '所选时间段暂无数据',
        error: '加载趋势失败',
      },
      managers: {
        name: '负责人',
        created: '已创建',
        inWorkNow: '处理中',
        success: '成功',
        refused: '拒绝',
        conversion: '转化率',
        volume: '体量',
      },
      refusal: {
        title: '拒绝原因',
        reasonHeader: '原因',
        countHeader: '数量',
      },
    },
  },
  clients: {
    title: '客户',
    emptyContacts: '没有活跃联系人',
    emptyLegal: '没有法人',
    emptyVersions: '没有版本历史',
    noPrimaryContact: '未设置主联系人',
    versionsCollapsed: '展开后才会加载历史记录。',
    actions: {
      create: '创建客户',
      addContact: '添加联系人',
      addLegal: '添加法人',
      addRequisites: '添加银行信息',
      callContact: '致电 {{name}}',
      checkResult: '刷新并核对',
      checkClientCreateResult: '刷新列表并关闭',
      createAnyway: '仍然创建该组',
      collapseText: '收起',
      copyInnOf: '复制 {{name}} 的 INN',
      copyPhoneOf: '复制 {{name}} 的电话',
      copyRequisites: '复制',
      copyRequisitesOf: '复制 {{entity}} 的银行信息「{{name}}」',
      expandRequisitesOf: '展开 {{name}} 的完整银行信息',
      expandText: '展开全部',
      setPrimary: '设为主联系人',
      showArchive: '显示归档 ({{count}})',
      hideArchive: '隐藏归档',
      showHistory: '显示历史',
      hideHistory: '隐藏历史',
      restoreVersion: '恢复此版本',
      viewVersion: '查看',
      viewVersionOf: '查看客户「{{name}}」的版本 #{{number}}',
      loadMore: '加载更多',
    },
    badges: {
      primary: '主联系人',
    },
    blocked: {
      archivePrimaryContact: '无法归档主联系人：请先将其他联系人设为主联系人。',
      archiveLastContact: '这是唯一一位活跃联系人：请先添加另一位。',
      alreadyPrimary: '该联系人已经是主联系人。',
      pendingAction: '对该记录的上一个操作仍在进行中。',
      pendingAncestor: '该客户的另一项更改仍在进行中，请等待结果。',
      archivedClient:
        '该客户已归档，无法修改。恢复该客户后才能再次编辑联系人、法人主体和银行信息。',
      archivedLegal: '该法人主体已归档，其银行信息无法修改。请先恢复该法人主体。',
    },
    fields: {
      name: '名称',
      comment: '备注',
      contactFullName: '姓名',
      contactComment: '联系人备注',
      phone: '电话',
      primaryContact: '主联系人',
      legalEntities: '法人',
      manager: '经理',
      status: '状态',
      inn: 'INN',
      legalType: '形式',
      legalName: '法人名称',
      requisites: '银行信息',
      bankName: '银行',
      bik: 'BIC',
      account: '账号',
      lifecycle: '阶段',
      lengthCounter: '{{length}} / {{max}} 个字符',
    },
    hints: {
      innOoo: '公司 INN 为 10 位数字。',
      innIp: '个体经营者 INN 为 12 位数字。',
      legalTypeImmutable: '创建后无法更改法人形式。',
      firstRequisites: '法人的第一组银行信息。其余可在客户卡片中添加。',
      requisitesDetails: '复制时会保留全文，包括换行。',
      optionalSlot: '可选。留空表示「未填写」。',
      phoneFormat: '国际格式，例如 +79991234567。',
    },
    filters: {
      toggle: '筛选',
      reset: '重置筛选',
      search: {
        label: '搜索',
        placeholder: '姓名、电话或 INN',
        truncated: '查询已截断为 {{max}} 个字符。',
      },
      archive: {
        label: '归档',
        active: '活跃',
        archived: '已归档',
        all: '全部',
      },
      manager: {
        label: '经理',
        any: '所有经理',
        invalid: '链接中的经理无法识别，列表未按经理筛选。',
      },
    },
    list: {
      loadedCount: '已加载：{{count}}',
      refreshing: '正在刷新…',
      anchorLost: '无法回到此前打开的那一行：当前列表中已没有该记录。',
      appendFailed: '下一页加载失败。已加载的行仍然保留。',
      refreshFailed: '列表刷新失败。显示的是此前加载的行。',
      stale: '以下为上一次的结果，正在更新…',
    },
    detail: {
      refreshFailed: '客户卡片刷新失败。显示的是此前加载的数据；已打开表单中输入的内容仍然保留。',
    },
    empty: {
      noResultsTitle: '未找到结果',
      noResultsText: '请修改查询或重置筛选。',
      archiveTitle: '归档为空',
      archiveText: '没有已归档的客户。',
      firstUseTitle: '暂无客户',
      firstUseText: '创建第一个客户即可开始。',
    },
    copy: {
      success: '已复制',
      failed: '复制失败。可以手动选择文本。',
      fallbackTitle: '无法复制',
      fallbackLabel: '待复制的文本',
    },
    requisites: {
      setOrdinal: '银行信息 #{{n}}',
      lastActiveHint: '这是唯一一组活跃的银行信息，无法归档。',
      inspectTitle: '法人「{{entity}}」当前的银行信息组',
      inspectHelp:
        '这是刷新后服务器上的状态。如果列表中没有您填写的那一组，请再次保存；如果已存在，请关闭编辑器。',
      inspectEmpty: '该法人没有任何银行信息组。',
    },
    restore: {
      summary:
        '恢复该版本将修改 {{changed}} 条记录，归档 {{archived}} 条，从归档中恢复 {{restored}} 条，重新创建 {{recreated}} 条。',
      renamedTo: '→ 将变为「{{name}}」',
      changedTitle: '将被修改',
      archivedTitle: '将被归档',
      restoredTitle: '将从归档中恢复',
      recreatedTitle: '将被重新创建',
      rootTitle: '客户字段',
      rootName: '名称',
      rootComment: '备注',
      rootArchive: '客户本身将被归档',
      rootUnarchive: '客户本身将从归档中恢复',
      noChanges: '保存的状态与当前状态一致——不会有任何变化。',
      managerKept: '记录归属人和客户经理保持不变。',
      banksNotRecorded: '快照仅保存银行信息文本，银行名称、BIC、账号及历史记录不会恢复。',
      missingLegal: '服务器将拒绝本次恢复：版本中记录的法人已不存在（{{names}}）。',
      contactLabel: '联系人「{{name}}」',
      legalLabel: '法人「{{name}}」',
      pending: '正在恢复——请勿关闭此窗口。',
      impactUnavailable: '未能加载客户的当前状态，因此无法显示变更列表。下方仅为保存的版本。',
    },
    conflict: {
      nameTaken: '同名客户已存在。请修改名称。',
      phoneTaken: '该电话已被其他记录占用。请核对号码。',
      innTaken: '该 INN 的法人已存在。请核对 INN。',
      clientArchived: '客户已归档。请先恢复后再修改。',
      legalArchived: '法人已归档。请先恢复后再修改。',
      requisitesArchived: '该组银行信息已归档。请先恢复后再修改。',
      restoreAmbiguous: '无法恢复该版本：无法确定它对应哪一组银行信息。',
      restoreAmbiguousDetail:
        '无法恢复该版本：无法确定它对应哪一组银行信息。未做任何修改。请手动核对法人（{{count}} 个）。',
      uncertainOutcome: '未收到服务器响应——记录可能已保存。请勿重复提交：刷新后核对结果。',
      uncertainInspected:
        '首次提交的结果仍然未知。请对照下方列表核对：只有当其中没有您的记录时才再次保存。',
      noVerdictRetry: '未收到服务器响应。没有任何内容丢失——请再试一次。',
      refreshFailed: '刷新数据失败。已输入的内容仍在——请再次尝试核对。',
    },
    legalType: {
      OOO: '有限责任公司 (OOO)',
      IP: '个体经营 (IP)',
    },
    modals: {
      createTitle: '新建客户',
      editTitle: '编辑客户',
      addContactTitle: '添加联系人：{{client}}',
      editContactTitle: '编辑联系人：{{client}}',
      addLegalTitle: '添加法人：{{client}}',
      editLegalTitle: '编辑法人：{{client}}',
      addRequisitesTitle: '添加银行信息：{{entity}}',
      editRequisitesTitle: '编辑银行信息：{{entity}}',
      versionTitle: '版本 #{{number}}',
    },
    sections: {
      summary: '概览',
      firstContact: '首个联系人',
      contacts: '联系人',
      legalEntities: '法人',
      versions: '版本历史',
    },
    confirm: {
      archiveTitle: '归档客户?',
      archiveMessage: '客户 "{{name}}" 将被归档。在恢复之前，子项更改将被阻止。',
      restoreTitle: '恢复客户?',
      restoreMessage: '客户 "{{name}}" 将再次可编辑。',
      archiveContactTitle: '归档联系人？',
      archiveContactMessage: '联系人「{{name}}」将被移入归档。',
      primaryContactTitle: '设为主联系人？',
      primaryContactMessage: '「{{name}}」将成为该客户的主联系人。',
      archiveLegalTitle: '归档法人？',
      archiveLegalMessage: '法人「{{name}}」及其银行信息将被归档，并变为只读。',
      archiveRequisitesTitle: '归档银行信息？',
      archiveRequisitesMessage: '{{entity}} 的银行信息「{{name}}」将被归档，文本仍可查看。',
      createAnywayTitle: '再创建一组？',
      createAnywayMessage:
        '第一次提交的结果未知。如果那一组已经保存，该法人将出现完全相同的第二组，只能由经理手动删除。',
      restoreVersionTitle: '恢复该版本？',
      restoreVersionMessage:
        '客户「{{name}}」的数据将被版本 #{{number}} 替换。当前状态会保留在历史中。',
    },
    errors: {
      invalidPhone: '请使用国际格式输入号码，例如 +79991234567',
      required: '请填写该字段——仅有空格不足以通过。',
      tooLong: '文本过长：不得超过 {{max}} 个字符。',
      tooLongUnbounded: '文本过长。',
      innOoo: '公司 INN 为 10 位数字，且校验位需正确。',
      innIp: '个体经营者 INN 为 12 位数字，且校验位需正确。',
      innAny: '请输入正确的 INN：公司为 10 位，个体经营者为 12 位。',
    },
    identifierTaken: {
      title: '该联系方式已被使用',
      body: '该联系方式已被另一条记录占用。请核对信息或使用其他联系方式。',
      bodyOwned: '该联系方式已归属于某个现有客户。请打开客户卡片以继续。',
      openClient: '打开客户',
    },
    toasts: {
      created: '客户已创建',
      saved: '更改已保存',
      archived: '客户已归档',
      restored: '客户已恢复',
      contactAdded: '联系人已添加',
      contactSaved: '联系人已更新',
      contactArchived: '联系人已归档',
      contactRestored: '联系人已恢复',
      contactPrimary: '主联系人已更改',
      legalAdded: '法人已添加',
      legalSaved: '法人已更新',
      legalArchived: '法人已归档',
      legalRestored: '法人已恢复',
      requisitesAdded: '银行信息已添加',
      requisitesSaved: '银行信息已更新',
      requisitesArchived: '银行信息已归档',
      requisitesRestored: '银行信息已恢复',
      versionRestored: '版本已恢复',
    },
    versionAction: {
      create: '已创建客户',
      update: '已更新客户',
      archive: '已归档客户',
      restore: '已恢复客户',
      versionRestore: '已从版本恢复',
      contactAdd: '已添加联系人',
      contactUpdate: '已更新联系人',
      contactArchive: '已归档联系人',
      contactRestore: '已恢复联系人',
      contactPrimary: '已设置主联系人',
      legalAdd: '已添加法人',
      legalUpdate: '已更新法人',
      legalArchive: '已归档法人',
      legalRestore: '已恢复法人',
      lifecycleWorking: '标记为合作客户',
    },
    lifecycle: {
      potential: '潜在',
      working: '合作中',
    },
  },
  carriers: {
    actions: {
      addPriceList: '添加价格表',
      addWarehouse: '添加仓库',
      attachFile: '附加文件',
      create: '添加承运商',
      open: '打开',
      preview: '预览',
      replaceFile: '替换文件',
      uploading: '上传中…',
    },
    columns: {
      contacts: '联系方式',
      name: '名称',
      notes: '备注',
      priceLists: '价格表',
      status: '状态',
      warehouses: '仓库',
    },
    empty: '未找到承运商',
    errors: {
      imageType: '请上传 PDF、JPG、PNG 或 WEBP 文件',
    },
    fields: {
      city: '城市',
      description: '描述',
      email: 'Email',
      file: '文件',
      name: '名称',
      noFile: '未选择文件',
      notes: '备注',
      optional: '可选',
      phone: '电话',
      priceListName: '价格表名称',
      warehouseName: '仓库名称',
    },
    filters: {
      active: '启用',
      all: '全部',
      inactive: '停用',
    },
    modals: {
      createTitle: '新承运商',
      editTitle: '承运商 — {{name}}',
    },
    search: '搜索',
    sections: {
      priceLists: '价格表',
      warehouses: '仓库',
    },
    status: {
      active: '启用',
      inactive: '停用',
    },
    title: '承运商',
    toasts: {
      activated: '承运商已启用',
      created: '承运商已创建',
      deactivated: '承运商已停用',
      fileUploaded: '文件已上传',
      priceListCreated: '价格表已添加',
      priceListDeleted: '价格表已删除',
      priceListUpdated: '价格表已更新',
      updated: '承运商已更新',
      warehouseCreated: '仓库已添加',
      warehouseDeleted: '仓库已删除',
      warehouseUpdated: '仓库已更新',
    },
  },
  arrivalCities: {
    actions: {
      create: '添加城市',
    },
    badges: {
      default: '默认',
    },
    columns: {
      default: '默认',
      name: '名称',
      shortName: '简称',
      status: '状态',
    },
    empty: '未找到到达城市',
    errors: {
      shortNameRegex: '简称需为 1-3 个西里尔字母、拉丁字母或数字',
    },
    fields: {
      isDefault: '默认到达城市',
      name: '名称',
      shortName: '简称',
      shortNameHelp: '最多 3 个字符：西里尔字母、拉丁字母或数字',
    },
    filters: {
      active: '启用',
      all: '全部',
      inactive: '归档',
    },
    modals: {
      createTitle: '新建到达城市',
      editTitle: '到达城市 — {{name}}',
    },
    search: '搜索',
    status: {
      active: '启用',
      inactive: '归档',
    },
    title: '到达城市',
    toasts: {
      activated: '城市已还原',
      archived: '城市已归档',
      created: '城市已创建',
      updated: '城市已更新',
    },
  },
  roadOptions: {
    actions: {
      create: '添加路线',
    },
    columns: {
      createdAt: '创建时间',
      name: '名称',
      sortOrder: '排序',
      status: '状态',
    },
    empty: '未找到路线',
    errors: {
      sortOrderInvalid: '排序：整数 ≥ 0',
    },
    fields: {
      name: '名称',
      sortOrder: '排序值',
      sortOrderHelp: '整数 ≥ 0；值越小越靠前',
    },
    filters: {
      active: '启用',
      all: '全部',
      inactive: '归档',
    },
    hints: {
      archivedRow: '已归档 — 新申请中不可选',
    },
    modals: {
      createTitle: '新建路线',
      editTitle: '路线 — {{name}}',
    },
    search: '搜索',
    status: {
      active: '启用',
      inactive: '已归档',
    },
    title: '路线',
    toasts: {
      activated: '路线已还原',
      archived: '路线已归档',
      created: '路线已创建',
      updated: '路线已更新',
    },
  },
  packagingOptions: {
    actions: {
      create: '添加包装',
    },
    columns: {
      createdAt: '创建时间',
      name: '名称',
      sortOrder: '排序',
      status: '状态',
    },
    empty: '未找到包装',
    errors: {
      sortOrderInvalid: '排序：整数 ≥ 0',
    },
    fields: {
      name: '名称',
      sortOrder: '排序值',
      sortOrderHelp: '整数 ≥ 0；值越小越靠前',
    },
    filters: {
      active: '启用',
      all: '全部',
      inactive: '归档',
    },
    hints: {
      archivedRow: '已归档 — 新申请中不可选',
    },
    modals: {
      createTitle: '新建包装',
      editTitle: '包装 — {{name}}',
    },
    search: '搜索',
    status: {
      active: '启用',
      inactive: '已归档',
    },
    title: '包装',
    toasts: {
      activated: '包装已还原',
      archived: '包装已归档',
      created: '包装已创建',
      updated: '包装已更新',
    },
  },
  russiaCarriers: {
    actions: {
      create: '添加承运商',
    },
    columns: {
      contacts: '联系方式',
      name: '名称',
      status: '状态',
    },
    empty: '未找到承运商',
    errors: {
      contactsRequired: '联系方式必填',
      nameRequired: '名称必填',
    },
    fields: {
      contacts: '联系方式',
      contactsHelp: '电话、邮箱、即时通讯——每条一行',
      name: '名称',
    },
    filters: {
      active: '启用',
      all: '全部',
      inactive: '已归档',
    },
    hints: {
      archivedRow: '已归档——新请求中不可用',
    },
    modals: {
      createTitle: '新建承运商',
      editTitle: '承运商 — {{name}}',
    },
    search: '搜索',
    status: {
      active: '启用',
      inactive: '已归档',
    },
    title: '俄方承运商',
    toasts: {
      activated: '承运商已还原',
      archived: '承运商已归档',
      created: '承运商已创建',
      updated: '承运商已更新',
    },
  },
  transportTypes: {
    actions: {
      create: '添加运输类型',
    },
    category: {
      container: '集装箱',
      truck: '卡车',
    },
    columns: {
      category: '类别',
      code: '代码',
      name: '名称',
      payload: '载重，吨',
      sortOrder: '#',
      status: '状态',
      volume: '体积，立方米',
    },
    empty: '未找到运输类型',
    errors: {
      payloadRange: '最大载重必须不小于最小载重',
      volumeRange: '最大体积必须不小于最小体积',
    },
    fields: {
      category: '类别',
      code: '代码',
      codeHint: '仅限小写 ASCII 字母、数字和 _，2–64 个字符。不可修改。',
      description: '描述',
      nameEn: '名称（EN）',
      nameRu: '名称（RU）',
      payloadMax: '最大载重，吨',
      payloadMin: '最小载重，吨',
      sortOrder: '排序',
      volumeMax: '最大体积，立方米',
      volumeMin: '最小体积，立方米',
    },
    filters: {
      active: '启用',
      all: '全部',
      categoryAll: '所有类别',
      inactive: '归档',
    },
    modals: {
      createTitle: '新建运输类型',
      editTitle: '运输类型 — {{name}}',
    },
    range: '{{min}} – {{max}}',
    search: '搜索',
    status: {
      active: '启用',
      inactive: '归档',
    },
    title: '运输类型',
    toasts: {
      activated: '运输类型已还原',
      archived: '运输类型已归档',
      created: '运输类型已创建',
      updated: '运输类型已更新',
    },
  },
  sources: {
    title: '线索来源',
    actions: {
      create: '添加来源',
      rotate: '轮换密钥',
      archive: '归档',
    },
    columns: {
      code: '代码',
      displayName: '名称',
      status: '状态',
      secretIssuedAt: '密钥下发时间',
    },
    status: {
      enabled: '启用',
      disabled: '停用',
      archived: '已归档',
    },
    filters: {
      active: '启用与停用',
      all: '包含已归档',
    },
    empty: {
      title: '尚未配置线索来源',
      text: '请创建第一个来源以开始接收线索。',
    },
    form: {
      createTitle: '新建线索来源',
      editTitle: '编辑线索来源',
      code: '代码',
      codeHelp: '仅限小写 ASCII 字母、数字、下划线。创建后不可修改。',
      codePlaceholder: 'website_intake',
      codeShapeError: '代码必须匹配 a-z、0-9、_（3–64 个字符)。',
      displayName: '名称',
      enabled: '启用 — 接收传入请求',
      create: '创建',
      save: '保存',
    },
    confirm: {
      rotate: '轮换密钥将立即作废旧密钥。新密钥只显示一次,是否继续?',
      archive: '归档此来源?后续传入请求将返回 410 Gone。',
    },
    reveal: {
      title: '线索来源密钥 — 仅显示一次',
      warning: '请立即复制此密钥。它不会再次显示;只能通过轮换恢复访问权限。',
      source: '来源',
      secret: '密钥',
      copy: '复制',
      copiedShort: '已复制',
      copied: '密钥已复制到剪贴板。',
      copyFallback: '剪贴板写入失败。请在关闭前手动选中并复制密钥值。',
      closeWithoutCopy: '不复制直接关闭',
    },
    toasts: {
      created: '已创建来源。关闭显示窗口前请复制密钥。',
      updated: '来源已更新',
      rotated: '密钥已轮换。关闭显示窗口前请复制新密钥。',
      archived: '来源已归档',
    },
    logs: {
      title: '投递日志 — {{code}}',
      empty: {
        title: '暂无投递日志',
        text: '当来源接收到首个请求后,日志将显示在此处。',
      },
      lead: '线索 {{id}}',
      idempotency: '幂等键 {{key}}',
    },
  },
  stages: {
    title: '线索阶段',
    hint: {
      lockedCatalog: '七个规范阶段已锁定。仅可编辑标签和任务模板。',
    },
    columns: {
      sortOrder: '#',
      code: '代码',
      kind: '类型',
      displayName: '显示标签',
      taskTitle: '主任务标题',
      defaultDueMinutes: '默认期限(分钟)',
      noTaskTitle: '无主任务',
    },
    kind: {
      ACTIVE: '活跃',
      TERMINAL: '终态',
    },
    empty: {
      title: '尚未初始化线索阶段',
      text: '请运行种子迁移以填充七个规范阶段。',
    },
    form: {
      editTitle: '编辑线索阶段',
      code: '代码',
      kind: '类型',
      displayName: '显示标签',
      taskTitle: '主任务标题',
      taskTitleClearHint: '留空以禁用自动创建任务',
      defaultDueMinutes: '默认期限(分钟)',
      defaultDueClearHint: '留空表示不设默认期限',
      defaultDueRange: '必须是 {{min}} 到 {{max}} 之间的整数',
      save: '保存',
    },
    toasts: {
      updated: '阶段已更新',
    },
  },
  warehouses: {
    columns: {
      carrier: '承运商',
      city: '城市',
      description: '描述',
    },
    empty: '未找到仓库',
    search: '搜索',
    title: '仓库',
    toasts: {
      copied: '描述已复制',
      copyFailed: '无法复制描述',
    },
  },
  priceLists: {
    columns: {
      carrier: '承运商',
      name: '价格表',
      preview: '文件',
    },
    empty: '未找到价格表',
    fileLabel: {
      file: '文件',
      image: '图片',
      pdf: 'PDF',
    },
    modalTitle: '{{carrier}} — {{name}}',
    search: '搜索',
    title: '价格表',
  },
  audit: {
    actorDeleted: '（已删除）',
    detailTitle: '事件：{{action}}',
    empty: '暂无记录',
    events: {
      arrivalCityArchive: '到达城市已归档',
      arrivalCityCreate: '到达城市已创建',
      arrivalCityRestore: '到达城市已还原',
      arrivalCityUpdate: '到达城市已更新',
      carrierCreate: '承运商已创建',
      carrierActivate: '承运商已启用',
      carrierDeactivate: '承运商已停用',
      carrierPriceListCreate: '承运商价格表已创建',
      carrierPriceListDelete: '承运商价格表已删除',
      carrierPriceListUpdate: '承运商价格表已更新',
      carrierUpdate: '承运商已更新',
      carrierWarehouseCreate: '承运商仓库已创建',
      carrierWarehouseDelete: '承运商仓库已删除',
      carrierWarehouseUpdate: '承运商仓库已更新',
      clientArchive: '客户已归档',
      clientContactAdd: '联系人已添加',
      clientContactArchive: '联系人已归档',
      clientContactRestore: '联系人已还原',
      clientContactSetPrimary: '主要联系人已更改',
      clientContactUpdate: '联系人已更新',
      clientCreate: '客户已创建',
      clientLegalAdd: '法人主体已添加',
      clientLegalArchive: '法人主体已归档',
      clientLegalRequisitesAdd: '银行信息已添加',
      clientLegalRequisitesArchive: '银行信息已归档',
      clientLegalRequisitesRestore: '银行信息已还原',
      clientLegalRequisitesUpdate: '银行信息已更新',
      clientLegalRestore: '法人主体已还原',
      clientLegalUpdate: '法人主体已更新',
      clientRestore: '客户已还原',
      clientUpdate: '客户已更新',
      clientVersionRestore: '已从历史版本还原客户',
      departmentArchive: '部门已归档',
      departmentCreate: '部门已创建',
      departmentRestore: '部门已恢复',
      departmentUpdate: '部门已更新',
      requestCarrierAdd: '已为申请添加承运商',
      requestBoxRegroup: '已重新分配箱内物品分组',
      requestCarrierRemove: '已从申请中移除承运商',
      requestCarrierUpdate: '承运商报价已更新',
      requestChat: '申请聊天消息',
      requestChatMarkUnread: '聊天标记为未读',
      requestChatUnmarkUnread: '已取消未读标记',
      requestCreate: '申请已创建',
      requestDelete: '申请已删除',
      requestDraftIdempotentResolve: '通过 clientToken 解析的草稿重复创建',
      requestChildRussiaCreated: '已从此请求创建俄罗斯运价请求',
      requestTransition: '申请状态已变更',
      requestUpdate: '申请已更新',
      requestWinner: '已选定中标方',
      roleArchive: '角色已归档',
      roleCreate: '角色已创建',
      rolePermissionsSet: '角色权限已更改',
      roleRestore: '角色已恢复',
      roleUpdate: '角色已更新',
      russiaRequestCreate: '俄罗斯需求已创建',
      russiaRequestDelete: '俄罗斯需求已删除',
      russiaRequestTransition: '俄罗斯需求状态已变更',
      russiaRequestUpdate: '俄罗斯需求已更新',
      russiaRequestChat: '俄罗斯需求聊天消息',
      russiaRequestChatMarkUnread: '俄罗斯需求聊天标记为未读',
      russiaRequestChatUnmarkUnread: '俄罗斯需求聊天已取消未读标记',
      cargoCreate: '创建货物',
      cargoUpdate: '更新货物',
      cargoDelete: '删除货物',
      cargoImport: '导入货物',
      cargoDocumentAdd: '添加货物付款单据',
      cargoDocumentDelete: '删除货物付款单据',
      cargoPaymentSet: '设置客户付款状态',
      cargoPaymentQuickSet: '快速设置客户付款',
      cargoPaymentRequestStatus: '请求客户付款状态',
      cargoPaymentReview: '审核客户付款',
      cargoProblemCreate: '已创建货物问题',
      cargoProblemUpdate: '已更新货物问题',
      cargoProblemTransition: '货物问题状态已更改',
      cargoProblemDelete: '已删除货物问题草稿',
      cargoProblemComment: '已添加货物问题评论',
      cargoProblemFileUpload: '已上传货物问题文件',
      cargoProblemAssigneeChange: '已更改货物问题负责人',
      cargoProblemAttachmentDelete: '已删除货物问题附件',
      cargoProblemReactionEscalate: '货物问题响应时限已升级',
      cargoClientTariffSet: '设置货物客户运费',
      cargoChinaPaymentSet: '设置中国付款',
      cargoCarrierPaymentSet: '设置承运商付款状态',
      cargoDictionaryChange: '更改货物字典',
      leadIntakeDutyToggle: '切换线索录入值班',
      callCenterAgentBind: '更改呼叫中心来源绑定',
      clientLifecycleWorking: '客户标记为合作',
      packagingOptionArchive: '包装已归档',
      packagingOptionCreate: '包装已创建',
      packagingOptionRestore: '包装已还原',
      packagingOptionUpdate: '包装已更新',
      russiaCarrierArchive: '俄方承运商已归档',
      russiaCarrierCreate: '俄方承运商已创建',
      russiaCarrierRestore: '俄方承运商已还原',
      russiaCarrierUpdate: '俄方承运商已更新',
      roadOptionArchive: '路线已归档',
      roadOptionCreate: '路线已创建',
      roadOptionRestore: '路线已还原',
      roadOptionUpdate: '路线已更新',
      transportTypeArchive: '运输类型已归档',
      transportTypeCreate: '运输类型已创建',
      transportTypeRestore: '运输类型已还原',
      transportTypeUpdate: '运输类型已更新',
      userChangePassword: '用户密码已修改',
      userCreate: '用户已创建',
      userDeactivate: '用户已停用',
      userReactivate: '用户已重新启用',
      userResetPassword: '用户密码已重置',
      userSelfUpdate: '用户已更新个人资料',
      userShiftToggle: '物流员切换值班状态',
      userUpdate: '用户已更新',
    },
    fields: {
      action: '操作',
      actor: '操作者',
      reason: '原因',
      target: '目标',
      time: '时间',
    },
    filters: {
      action: '操作',
      actor: '操作者',
      actorPlaceholder: '操作者（UUID）',
      all: '全部',
      allActions: '全部操作',
      dateFrom: '从',
      dateFromPlaceholder: '从（ISO）',
      dateTo: '到',
      dateToPlaceholder: '到（ISO）',
      targetId: '目标 ID',
      targetType: '目标类型',
    },
    loadMore: '加载更多',
    noDiff: '无 diff',
    title: '审计日志',
  },
  departments: {
    actions: {
      create: '创建部门',
      unarchive: '取消归档',
    },
    columns: {
      name: '名称',
      status: '状态',
    },
    confirm: {
      archiveText: '部门“{{name}}”将不能再分配给新员工。现有员工会保留该部门。',
      archiveTitle: '归档部门',
      restoreText: '部门“{{name}}”将重新可分配给员工。',
      restoreTitle: '取消部门归档',
    },
    detail: {
      archivedSuffix: '已归档',
      back: '← 部门',
      employees: '员工：{{total}}（启用：{{active}}）',
      emptyEmployees: '该部门还没有员工',
      loadEmployeesError: '无法加载员工',
    },
    empty: '尚未创建部门',
    fields: {
      namePlaceholder: '部门名称',
    },
    modals: {
      createTitle: '新建部门',
      renameTitle: '重命名部门',
    },
    title: '部门',
    toasts: {
      archived: '部门已归档',
      created: '部门已创建',
      renamed: '部门已重命名',
      restored: '部门已恢复',
    },
  },
  roles: {
    actions: {
      archiveSystem: '归档（系统）',
      create: '创建角色',
    },
    columns: {
      identifier: '标识符',
      name: '名称',
      status: '状态',
      type: '类型',
    },
    confirm: {
      archiveText:
        '角色“{{name}}”将被归档。现有用户会保留该角色，但新建或编辑用户时不能再分配此角色。',
      archiveTitle: '归档角色',
      restoreText: '角色“{{name}}”将重新可分配给用户。',
      restoreTitle: '恢复角色',
    },
    empty: '尚未创建角色',
    fields: {
      description: '描述',
      descriptionOptional: '描述（可选）',
      displayName: '显示名称',
      identifier: '标识符',
      identifierCreate: '标识符（小写，无点号）',
      displayNamePlaceholder: '销售经理',
    },
    modals: {
      createTitle: '新建角色',
    },
    tabs: {
      details: '详情',
      permissions: '权限',
      users: '用户',
    },
    title: '角色',
    toasts: {
      archived: '角色已归档',
      created: '角色已创建',
      permissionsUpdated: '权限已更新',
      restored: '角色已恢复',
      updated: '角色已更新',
    },
    users: {
      empty: '没有用户分配到此角色。',
    },
  },
  users: {
    actions: {
      changePassword: '修改密码',
      create: '创建用户',
      reset: '重置',
    },
    confirm: {
      emailChangeConfirm: '修改邮箱',
      emailChangeText: '修改邮箱会终止该用户的所有活动会话。继续吗？',
      emailChangeTitle: '确认修改邮箱',
    },
    empty: '没有用户',
    errors: {
      invalidPhone: '请按国际格式输入号码，例如 +79991234567',
    },
    fields: {
      currentPassword: '当前密码',
      department: '部门',
      name: '姓名',
      newPassword: '新密码',
      password: '密码',
      phone: '电话',
      role: '角色',
      status: '状态',
    },
    filters: {
      active: '启用',
      inactive: '停用',
    },
    modals: {
      changePasswordTitle: '修改密码',
      createTitle: '新建用户',
      deactivateText: '该用户的所有活动会话将被强制终止。',
      deactivateTitle: '停用 {{name}}',
      reactivateText: '该用户将可以重新登录系统。',
      reactivateTitle: '重新启用 {{name}}',
      resetPasswordTitle: '重置 {{name}} 的密码',
    },
    placeholders: {
      departmentLoading: '正在加载部门…',
      departmentSelect: '选择部门',
      roleLoading: '正在加载角色…',
      roleSelect: '选择角色',
      deactivationReason: '停用原因…',
    },
    password: {
      confirmNew: '确认新密码',
      confirmRequired: '请确认新密码',
      mismatch: '两次输入的密码不一致',
      newMustDiffer: '新密码必须不同于当前密码',
      requirement: '至少 12 个字符。',
      requirementWithDifference: '至少 12 个字符，且必须不同于当前密码。',
    },
    tabs: {
      actions: '操作',
      profile: '资料',
    },
    title: '用户',
    toasts: {
      changePasswordSuccess: '密码已更新。请重新登录。',
      created: '用户已创建',
      deactivated: '用户已停用',
      reactivated: '用户已重新启用',
      resetPassword: '密码已重置。用户会看到“需要修改密码”标记。',
      saved: '更改已保存',
    },
  },
  revenue: {
    title: '营收',
    monthSelectLabel: '月份',
    chart: {
      title: '按日累计营收',
      empty: '暂无可绘制的数据。',
    },
    kpi: {
      total: '月度合计',
      buyouts: '代采',
      foreignTrade: '外贸',
      logistics: '物流',
    },
    comparison: {
      previousMonth: '上月对比',
      previousYear: '同比对比',
      selectedTotal: '当前周期',
      comparisonTotal: '对比周期',
      noData: '可比周期暂无数据。',
      sheetMissing: '未找到用于对比的工作表。',
    },
    manager: {
      name: '负责人',
      total: '合计',
      buyouts: '代采',
      foreignTrade: '外贸',
      logistics: '物流',
    },
    source: {
      label: '数据来源:',
      warning: '外部 Google Sheets 表格。该表格以链接共享 — 拥有链接的任何人均可查看其内容。',
    },
    freshness: {
      fetchedAt: '更新于 {{time}}',
    },
    stale: {
      banner: '显示的是缓存数据',
      generic: '无法刷新数据。',
      upstream_timeout: '表格响应超时。',
      upstream_5xx: '表格暂时不可用。',
      upstream_4xx: '表格访问被拒绝。',
      parse_error: '无法解析表格响应。',
      network_error: '访问表格时出现网络错误。',
    },
    errors: {
      notConfiguredTitle: '未配置数据源',
      notConfiguredText: '环境变量 REVENUE_GOOGLE_SHEETS_SOURCE 未设置，请联系管理员。',
      sourceInvalidTitle: '数据源配置无效',
      sourceInvalidText: 'REVENUE_GOOGLE_SHEETS_SOURCE 不像有效的 Google Sheets 标识符。',
      sourceUnavailableTitle: '数据源不可用',
      sourceUnavailableText: '无法从 Google Sheets 获取数据。请尝试刷新。',
      invalidMonthTitle: '月份无效',
      invalidMonthText: '需要 YYYY-MM 格式的月份。',
      monthNotFoundTitle: '未找到月份',
      monthNotFoundText: '数据源中没有所选月份对应的工作表。',
    },
  },
  crm: {
    requests: {
      title: '需求单',
      empty: '暂无关联需求单',
      error: '无法加载需求单',
      slaLabel: 'SLA 截止时间',
      createAction: '创建需求单',
    },
  },
  leads: {
    title: '线索',
    empty: '暂无线索',
    actions: {
      create: '新建线索',
      loadMore: '加载更多',
      claim: '认领',
    },
    fields: {
      publicCode: '编号',
      name: '姓名',
      phone: '电话',
      email: '邮箱',
      comment: '备注',
      title: '主题',
      stage: '阶段',
      manager: '负责人',
      client: '客户',
      status: '状态',
      unassigned: '未分配',
      intake: '呼叫中心',
    },
    filters: {
      search: {
        label: '搜索',
        placeholder: '主题、姓名、电话或编号',
      },
      stage: {
        label: '阶段',
        allLabel: '全部阶段',
      },
      source: {
        label: '来源',
        allLabel: '全部来源',
      },
      unassigned: {
        label: '分配',
        all: '全部线索',
        only: '仅未分配',
      },
      archive: {
        label: '归档',
        active: '活动',
        archived: '已归档',
        all: '全部',
      },
      manager: {
        label: '负责人',
        placeholder: '全部负责人',
      },
    },
    intake: {
      title: '呼叫中心提交',
      empty: '暂无呼叫中心提交',
      audioLink: '通话录音',
      countTitle: '呼叫中心提交数',
      source: '来源',
      submittedBy: '提交人',
      outcome: {
        CREATED_LEAD: '已创建线索',
        DUPLICATE_EXISTING_LEAD: '与现有线索重复',
        REJECTED_VALIDATION: '已拒绝：校验失败',
        REJECTED_SOURCE_DISABLED: '已拒绝：来源已禁用',
        REJECTED_NO_PROFILE: '已拒绝：无档案',
        INTERNAL_ERROR: '内部错误',
      },
    },
    attention: {
      title: '需要关注',
      resolve: '完成',
      empty: '暂无需要关注的事项',
      callbackUrgent: '紧急回电',
    },
    stage: {
      new: '新建',
      inWork: '处理中',
      postponed: '推迟',
      awaitingPayment: '等待付款',
      returned: '已退回',
      notSuitable: '不合适',
      refusal: '拒绝',
      paid: '已付款',
    },
    stageControls: {
      pickTarget: '选择阶段',
      apply: '转换',
      paidRequiresClient: '请先绑定客户后再转为「已付款」。',
      terminalNote: '终止阶段——无法继续转换。',
      archivedNote: '线索已归档——无法转换。',
    },
    modals: {
      createTitle: '新建线索',
    },
    duplicates: {
      title: '已有相同电话的线索',
      body: '如属同一商机，请打开现有线索。',
      archived: '已归档',
      open: '打开',
      createdPrefix: '已创建线索：',
    },
    phoneExists: {
      title: '该电话号码已被使用',
      body: '已存在使用该电话的记录。请打开它以继续。',
      bodyWithCode: '记录 {{code}} 已使用该电话。请打开它以继续。',
      openLead: '打开现有线索',
      openClient: '打开现有客户',
    },
    client: {
      none: '未绑定客户',
      bind: '绑定客户',
      unbind: '解绑',
      openClient: '打开客户卡片',
      searchPlaceholder: '按姓名、电话或税号搜索',
      empty: '无匹配',
    },
    match: {
      title: '将线索绑定到客户',
      confirm: '绑定',
      loading: '正在匹配联系人…',
      loadError: '加载联系人失败',
      targetLabel: '客户联系人',
      contactNameLabel: '新联系人姓名',
      contactMatched: '{{name}}（联系方式匹配）',
      createOption: '创建新联系人',
    },
    admin: {
      title: '管理员操作',
      pickManager: '选择负责人',
      reassign: '分配',
      noAssignableManagers: '暂无可选负责人',
    },
    errors: {
      invalidPhone: '请使用国际格式输入号码，例如 +79991234567',
    },
    toasts: {
      created: '线索已创建',
      stageChanged: '阶段已更新',
      clientBound: '客户已绑定',
      clientUnbound: '客户已解绑',
      claimed: '线索已认领',
      archived: '线索已归档',
      restored: '线索已恢复',
      reassigned: '负责人已变更',
    },
    activity: {
      feed: {
        title: '动态',
        empty: '暂无动态',
        actorSystem: '系统',
        commentDeleted: '（评论已删除）',
        fileDeleted: '（文件已删除）',
      },
      kind: {
        LEAD_CREATED: '创建了线索',
        LEAD_STAGE_CHANGED: '修改了阶段',
        LEAD_ASSIGNED: '指派了负责人',
        LEAD_UNASSIGNED: '移除了负责人',
        LEAD_CLIENT_BOUND: '绑定了客户',
        LEAD_CLIENT_UNBOUND: '解除了客户绑定',
        LEAD_TASK_CREATED: '创建了任务',
        LEAD_TASK_COMPLETED: '完成了任务',
        LEAD_TASK_CANCELLED: '取消了任务',
        LEAD_TASK_REOPENED: '重新打开了任务',
        LEAD_COMMENT_ADDED: '添加了评论',
        LEAD_COMMENT_EDITED: '编辑了评论',
        LEAD_ARCHIVED: '归档了线索',
        LEAD_RESTORED: '恢复了线索',
        LEAD_REQUEST_LINKED: '关联了请求',
        LEAD_REQUEST_UNLINKED: '取消了请求关联',
        LEAD_FILE_UPLOADED: '上传了文件',
        LEAD_FILE_DELETED: '删除了文件',
        LEAD_INTAKE_RECEIVED: '收到呼叫中心提交的线索',
        CALL: '记录了一通通话',
        MESSAGE: '记录了一条消息',
      },
      comments: {
        title: '评论',
        empty: '暂无评论',
        authorDeleted: '（作者已删除）',
        composerPlaceholder: '添加评论…',
        composerAriaLabel: '新评论',
        editAriaLabel: '编辑评论',
        submit: '添加',
        revisions_one: '{{count}} 次修改',
        revisions_few: '{{count}} 次修改',
        revisions_many: '{{count}} 次修改',
        revisions_other: '{{count}} 次修改',
        errors: {
          tooLong: '评论不能超过 {{max}} 个字符',
        },
        toasts: {
          created: '评论已添加',
          updated: '评论已更新',
        },
      },
      files: {
        title: '文件',
        empty: '暂无文件',
        upload: '上传文件',
        uploading: '上传中…',
        uploaderDeleted: '（上传者已删除）',
        usage: '已使用 {{count}}/{{max}}',
        maxSize: '最大 {{size}}',
        capReached: '该线索的文件数量已达上限。',
        confirmDelete: {
          title: '删除文件？',
          text: '将删除文件「{{name}}」。此操作无法撤销。',
        },
        errors: {
          tooLarge: '文件超过 {{size}}',
          unsupportedMime: '不支持的文件类型',
          nameTooLong: '文件名超过 {{max}} 个字符',
        },
        toasts: {
          uploaded: '文件已上传',
          deleted: '文件已删除',
        },
      },
      note: {
        title: '备注',
        placeholder: '写下备注…',
        submit: '保存',
        toasts: {
          created: '备注已添加',
        },
      },
      communications: {
        callTitle: '记录通话',
        messageTitle: '记录消息',
        directionLabel: '方向',
        channelLabel: '渠道',
        occurredAtLabel: '日期和时间',
        textLabel: '备注',
        textPlaceholder: '沟通了什么…',
        transcriptPlaceholder: '暂无转录',
        communicationDeleted: '（沟通记录已删除）',
        submit: '保存',
        direction: {
          INBOUND: '呼入',
          OUTBOUND: '呼出',
        },
        channel: {
          PHONE: '电话',
          WHATSAPP: 'WhatsApp',
          TELEGRAM: 'Telegram',
        },
        toasts: {
          created: '沟通记录已保存',
        },
      },
    },
    episode: {
      tabs: {
        feed: '动态',
        tasks: '任务',
        tasksCount: '任务（{{count}}）',
        client: '客户',
        requests: '申请',
        requestsCount: '申请（{{count}}）',
      },
      clientSummary: {
        title: '客户',
      },
      otherEpisodes: {
        title: '客户的其他阶段',
        leadsTitle: '线索',
        dealsTitle: '商机',
        leadsEmpty: '暂无其他线索',
        dealsEmpty: '暂无其他商机',
      },
      capture: {
        note: '备注',
        file: '文件',
        call: '通话',
        message: '消息',
      },
      upcoming: {
        title: '已安排',
        empty: '暂无已安排的任务',
      },
      filters: {
        toggle: '筛选',
        category: '类型',
        searchLabel: '搜索',
        searchPlaceholder: '搜索动态…',
      },
      feedTabs: {
        all: '全部',
        notes: '备注',
        system: '系统',
      },
    },
    tasks: {
      title: '任务',
      empty: '暂无未完成任务',
      openCount_one: '{{count}} 个进行中',
      openCount_few: '{{count}} 个进行中',
      openCount_many: '{{count}} 个进行中',
      openCount_other: '{{count}} 个进行中',
      overdueCount: '{{count}} 个已逾期',
      create: '新建任务',
      noDue: '无截止日期',
      autoHint: '自动任务 — 由系统管理',
      actions: {
        reschedule: '改期',
        complete: '完成',
        cancel: '取消',
        reopen: '恢复',
      },
      cancelled: {
        title: '已取消',
      },
      form: {
        createTitle: '新建任务',
        editTitle: '任务改期',
        titleLabel: '标题',
        titlePlaceholder: '需要做什么？',
        dueLabel: '截止日期',
      },
      toasts: {
        created: '任务已创建',
        rescheduled: '任务已更新',
        completed: '任务已完成',
      },
    },
    buckets: {
      all: '全部',
      unassigned: '未分配',
      new: '新建',
      inWork: '处理中',
      closing: '成交办理',
      deal: '订单',
      postponed: '已推迟',
      noClient: '无客户',
      closed: '已关闭',
    },
    list: {
      contact: '联系人',
      company: '客户',
      lead: '线索',
      noContact: '未命名',
      noClientLinked: '未关联客户',
      noCompany: '—',
      tasksColumn: '任务',
      noNextStep: '无下一步',
      unqualified: '未评定资格',
      updated: '更新时间',
      totalCount_one: '{{count}} 个业务',
      totalCount_few: '{{count}} 个业务',
      totalCount_many: '{{count}} 个业务',
      totalCount_other: '{{count}} 个业务',
      score: '评分',
      overdue: '已逾期',
      resumeAt: '恢复 {{date}}',
      sortLabel: '排序',
      sortRecent: '最新优先',
      sortOldest: '最早优先',
      scoreLabel: '评分',
      scoreAll: '任意评分',
      clientLabel: '客户筛选',
      clientActive: '客户：{{name}}',
      clientClear: '清除客户筛选',
      filtersToggle: '筛选',
    },
    card: {
      title: '线索',
      funnel: {
        new: '新建',
        inWork: '处理中',
        closing: '成交办理',
        deal: '成交',
      },
      inWorkLocked: '请先绑定客户，再将线索转入处理',
      actions: {
        postpone: '推迟',
        refuse: '拒绝',
        nonTarget: '非目标',
        backToWork: '重新处理',
      },
      dealCode: '订单',
      score: {
        ariaLabel: '评分 {{score}}/5',
        unrated: '未评分',
        qualifyPrompt: '评定资格',
      },
      contact: '联系人',
      unnamed: '未命名',
      client: {
        title: '客户',
      },
      clientActions: '客户操作',
      titleEdit: {
        edit: '编辑主题',
        placeholder: '线索主题',
        saved: '主题已更新',
      },
      contactActions: {
        call: '拨打电话',
        email: '发送邮件',
        telegram: 'Telegram — 暂无数据',
        whatsapp: 'WhatsApp — 暂无数据',
        max: 'MAX — 暂无数据',
      },
      banner: {
        postponed: '已推迟 · 将于 {{date}} 重新处理',
        resume: '立即重新处理',
        terminalRefused: '已拒绝 · 只读卡片',
        terminalNonTarget: '非目标 · 只读卡片',
        deal: '订单 {{dealCode}} · 付款已确认',
        dealNoCode: '订单 · 付款已确认',
      },
      artifacts: {
        title: '资料',
        menuLabel: '添加资料',
        addFile: '文件',
        addProposal: '商业报价',
        system: '系统内',
        empty: '暂无内容。创建后商业报价和申请将自动显示。',
        kind: {
          request: '中国申请',
          'russia-request': '俄罗斯申请',
          deal: '订单',
          proposal: '商业报价',
        },
      },
    },
    checklist: {
      title: '成交办理清单',
      progress: '{{done}}/{{total}}',
      optional: '可选',
      confirmPaymentHint: '付款通过将阶段切换为「已付款」来确认',
      status: {
        TODO: '待办',
        DONE: '已完成',
        SKIPPED: '已跳过',
      },
      items: {
        contract_legal_entities_check: '核对合同法人主体',
        spec: '规格书',
        contract: '合同',
        issue_invoice: '开具发票',
        send_invoice: '发送发票',
        receive_payment_slip: '收取付款凭证',
        confirm_payment: '确认付款',
      },
    },
  },
  deals: {
    title: '商机',
    empty: '暂无商机',
    wonCount: '商机（已赢）',
    actions: {
      loadMore: '加载更多',
    },
    fields: {
      publicCode: '编号',
      client: '客户',
      manager: '负责人',
      lead: '来源线索',
      unlinked: '未关联',
      updated: '更新时间',
    },
  },
  myDay: {
    title: '我的一天',
    timezone: '时区：{{tz}}',
    empty: {
      title: '暂无任务',
      text: '任务在分配或临近截止时将显示在此处。',
    },
    bucket: {
      overdue: '已逾期',
      today: '今天',
      upcoming: '即将到期',
      blocked: '已阻塞',
    },
    bucketEmpty: {
      overdue: '没有逾期任务。',
      today: '今天没有任务。',
      upcoming: '没有即将到期的任务。',
      blocked: '没有阻塞的任务。',
    },
    row: {
      complete: '完成',
      completing: '保存中…',
      stagePrimary: '阶段',
      callbackUrgent: '紧急回电',
      openLeadAria: '打开线索 {{code}}',
    },
    requests: {
      title: '需要处理的请求',
      loading: '正在加载请求…',
      empty: '没有需要处理的请求。',
      error: {
        title: '无法加载请求',
        text: '无法加载需要处理的请求。请重试。',
      },
      signal: {
        returned: '已退回',
        slaHot: '即将到期',
        readyToPick: '可选择中标方',
        unreadChat: '未读聊天',
      },
    },
  },
  callCenter: {
    intake: {
      title: '新线索',
      fields: {
        phone: '电话',
        name: '客户姓名',
        comment: '备注',
        audioUrl: '通话录音链接',
      },
      submit: '提交线索',
      success: '线索已提交，可以录入下一条。',
      logout: '退出登录',
      noAccess: {
        title: '无访问权限',
        text: '您的账户无权访问线索录入表单。请联系管理员。',
      },
      errors: {
        invalidPhone: '电话号码无效',
        invalidAudioUrl: '录音链接无效（需为 https 地址）',
      },
    },
    selfService: {
      title: '我的线索',
      newLead: '新线索',
      searchPlaceholder: '按电话搜索',
      filters: '筛选',
      empty: '您还没有提交任何线索。',
      loadMore: '加载更多',
      loading: '加载中…',
      submitSuccess: '线索已提交。',
      ownDuplicate: '您已提交过使用此电话号码的线索',
      columns: {
        phone: '电话',
        name: '客户姓名',
        comment: '备注',
        audioUrl: '通话录音',
        createdAt: '添加时间',
      },
      audioLink: '打开录音',
      detail: {
        title: '线索',
        noComment: '无备注',
        noAudio: '无录音',
      },
      newLeadDrawer: {
        title: '新线索',
      },
    },
  },
  callCenterAdmin: {
    pageTitle: '呼叫中心与经理值班',
    fields: {
      email: '邮箱',
      source: '来源',
    },
    placeholders: {
      sourceSelect: '选择来源',
    },
    accounts: {
      title: '呼叫中心账户',
      create: '创建账户',
      empty: '暂无呼叫中心账户。',
      colName: '姓名',
      colBinding: '来源',
    },
    binding: {
      none: '未绑定',
      warning: '需要处理',
    },
    actions: {
      rebind: '更换来源',
    },
    create: {
      title: '新建呼叫中心账户',
    },
    rebind: {
      title: '更换来源绑定',
    },
    duty: {
      title: '经理线索录入值班',
      empty: '没有符合条件的经理。',
      emptyDutyWarning: '没有经理在值班——新线索无人可分配。',
      on: '值班中',
      off: '未值班',
      ariaOn: '值班中——点击下班',
      ariaOff: '未值班——点击上班',
    },
    toasts: {
      created: '账户已创建。',
      rebound: '来源已更换。',
    },
  },
  logisticsCalculations: {
    title: '运单',
    loading: '正在加载…',
    error: '无法加载计算。',
    empty: '暂无计算。',
    statuses: { DRAFT: '草稿', PUBLISHED: '已发布' },
    delete: {
      title: '删除草稿 {{code}}？',
      text: '草稿将被永久删除。其货物可再次加入其他运单。',
      textRevoked: '该文档曾发布并撤销。将连同查看记录一并永久删除；其货物可再次加入其他运单。',
      done: '草稿 {{code}} 已删除',
    },
    paymentLabels: { novat: '不含增值税', vatIncluded: '含增值税', individual: '个人付款' },
    payableCurrencies: { RUB: '卢布', USD: '美元', USD_RUB: '美元 + 卢布' },
    sections: {
      chinaLogistics: '中国物流',
      chinaExpenses: '中国费用',
      rfExpenses: '俄罗斯费用',
      rfLogistics: '俄罗斯物流',
    },
    units: {
      kg: '公斤',
      m3: '立方米',
      package: '件',
      item: '项',
      cargo: '货物',
      trip: '趟',
      day: '天',
      fixed: '固定',
      custom: '自定义',
    },
    list: {
      number: '编号',
      status: '状态',
      client: '客户',
      owner: '经理',
      cargos: '货物',
      totalUsd: '合计 $',
      totalRub: '合计 ₽',
      views: '浏览量',
      updated: '更新时间',
    },
    detail: {
      totalUsd: '美元合计',
      totalRub: '卢布合计',
      htmlViews: '页面浏览量',
    },
    document: {
      narrowNotice: '本文档按 A4 宽度排版，填写需要更宽的屏幕。此处仅供阅读 — 表格可横向滚动。',
    },
    actions: {
      create: '新建运单',
      cancel: '取消',
      close: '关闭',
      creating: '正在创建…',
      createDraft: '创建草稿',
      save: '保存',
      edit: '编辑',
      publish: '发布',
      revoke: '撤销',
      delete: '删除',
      copyLink: '复制链接',
      linkCopied: '链接已复制',
      downloadPdf: '下载 PDF',
      back: '返回列表',
    },
    editor: {
      title: '新建计算',
      editTitle: '编辑 {{code}}',
      createError: '无法创建草稿。',
      publishError: '无法发布文档。',
      publishNotReady: '请删除文档旧版本遗留的未填写服务。',
      numberAfterSave: '保存后分配编号',
      validationError: '请检查必填字段后重试。',
      cargoHeld: '该货物已在计算单 {{code}} 中。请删除该行，或在该单据中释放它。',
      cargoHeldUnknown: '该货物已在其他计算单中。请从本单据中删除该行。',
      prefill: {
        held: '该货物已在计算单 {{code}} 中，因此本单据未包含它。',
        unchecked: '无法核验该货物。您可以从下方的登记册中添加该货物。',
      },
      fields: {
        style: '文档样式',
        clientCompany: '公司',
        clientContactName: '联系人',
        clientContactPhone: '电话',
        payDueDate: '付款截止日',
        paymentLabel: '付款条款',
        paymentDivisor: '除数',
        paymentDivisorHint: '合计 / {{divisor}} = 应付',
        payableCurrency: '支付货币',
        rubPerUsdRate: '美元汇率（₽/1美元）',
        rubPerCnyRate: '人民币汇率（₽/1元）',
        managerName: '经理姓名',
        managerPhone: '经理电话',
        managerTelegram: '经理 Telegram',
      },
      cargoPicker: {
        label: '从登记册添加货物',
        placeholder: '输入货号或名称',
        choose: '选择货物',
        add: '添加',
        added: '已添加货物 {{article}}。',
        duplicate: '货物 {{article}} 已添加。',
        heldOption: '已在计算单 {{code}} 中',
        heldMessage: '该货物已在计算单 {{code}} 中。请先在该单据中释放，再添加到此处。',
      },
      cargo: {
        title: '货物 {{number}}',
        remove: '移除货物',
        empty: '请至少添加一个货物。',
        article: '货号',
        name: '名称',
        seats: '件数',
        weight: '重量',
        volume: '体积',
        transportType: '运输方式',
        departedAt: '发出时间',
        arrivedAt: '到达时间',
        invalidDateTime: '请输入有效的日期和时间。',
      },
      cost: {
        amount: '{{column}}：金额',
        caption: '{{column}}：说明',
        currency: '{{column}}：货币',
        hints: {
          transport: '250 kg * $4.5 = $1 125',
          insurance: '$2 300 的 1%',
          extra: '费用说明',
        },
        addExtra: '添加额外费用',
        removeExtra: '删除额外费用 {{index}}',
        removeLine: '删除服务',
      },
    },
  },
  logisticsCalculationsPublic: {
    loading: '正在加载计算…',
    notFound: { title: '未找到计算', body: '此链接无效或已不可用。' },
    downloadPdf: '下载 PDF',
  },
  validation: {
    required: '必填字段',
  },
} as const satisfies typeof ru;
